const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTips(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BADDA4"
    },
    d: "M250.672,442.995c-0.493,0.675-1.144,1.659-0.761,2.519c0.353,0.805,1.441,1.087,2.154,1.45 c1.687,0.86,2.56,2.45,2.589,4.325c0.026,1.925-0.992,3.644-2.361,4.938c-1.563,1.478-3.539,2.386-5.391,3.438 c-1.503,0.853-3.649,2.119-3.782,4.081c-0.14,2.041,2.979,1.679,4.266,1.993c1.702,0.414,2.828,1.807,2.992,3.54 c0.415,4.379-3.962,6.297-7.288,7.781l-13.309,5.921c-0.006-0.001-0.006,0.005-0.007,0.01c-0.204,0.353-0.523,0.438-0.822,0.356 c0,0-1.801-1.037-0.812-1.473c0.14-0.063,0.281-0.125,0.421-0.188c0.723-1.539,0.646-3.325,0.108-4.919 c-1.421-4.218-5.504-6.47-9.084-8.636c-1.736-1.049-3.557-2.1-4.656-3.874c-0.895-1.453-0.884-3.361,0.477-4.531 c1.124-0.965,2.696-1.013,4.097-1.129c1.372-0.109,3.182-0.227,3.742-1.741c0.654-1.783-0.504-3.646-1.721-4.861 c-1.471-1.466-3.304-2.587-4.466-4.348c-0.999-1.514-1.6-3.6-0.81-5.344c0.645-1.41,1.983-2.227,3.478-2.464 c1.506-0.235,3.031-0.03,4.547-0.008c1.317,0.024,2.885-0.071,3.72-1.252c1.168-1.666,0.263-3.976-0.436-5.63 c-0.783-1.837-1.687-3.835-1.23-5.87c0.354-1.575,1.542-3.187,3.216-3.48c1.038-0.18,1.881,0.25,2.798,0.681 c0.838,0.395,1.685,0.485,2.568,0.173c4.725-1.652,3.584-7.972,3.779-11.806c0.102-2.086,0.52-4.377,1.875-6.042 c1.136-1.394,2.838-2.328,4.653-2.372c1.849-0.044,3.434,1.1,4.195,2.752c0.853,1.859,0.848,4.046,0.832,6.056 c-0.021,2.428-0.283,4.846-0.771,7.221c-0.248,1.196-0.664,2.41-0.68,3.643c-0.01,0.877,0.337,2.072,1.305,2.329 c0.707,0.187,1.404-0.24,1.982-0.589c0.702-0.42,1.364-0.909,2.126-1.207c1.752-0.677,3.543-0.078,4.63,1.45 c1.284,1.821,1.11,4.071,0.214,6.025c-0.981,2.161-2.486,4.125-3.95,5.976c-0.733,0.931-1.495,1.829-2.288,2.711 C252.096,441.393,251.308,442.134,250.672,442.995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M244.835,469.033c-3.938,1.815-7.876,3.631-11.813,5.446c2.006-5.872,3.755-11.832,5.226-17.861 c0.067-0.275,0.129-0.551,0.195-0.826c0.019-0.006,0.037-0.006,0.056-0.016c3.768-1.949,7.536-3.897,11.303-5.846 c0.39-0.202,0.016-0.773-0.371-0.573c-3.596,1.86-7.191,3.719-10.787,5.579c1.269-5.392,2.307-10.838,3.143-16.314 c3.769-2.894,7.538-5.788,11.307-8.682c0.346-0.266-0.022-0.841-0.371-0.573c-3.594,2.759-7.187,5.519-10.781,8.278 c0.331-2.242,0.634-4.488,0.891-6.74c0.556-4.876,0.937-9.772,1.147-14.676c0.019-0.439-0.662-0.396-0.681,0.039 c-0.306,7.132-0.995,14.245-2.038,21.307c-3.547-3.069-7.094-6.137-10.641-9.206c-0.332-0.287-0.787,0.222-0.454,0.509 c3.653,3.16,7.306,6.321,10.959,9.481c-0.029,0.08-0.037,0.162-0.008,0.24c-0.181,1.186-0.37,2.371-0.572,3.554 c-0.737,4.321-1.612,8.619-2.621,12.885c-3.591-3.5-7.181-7.001-10.772-10.501c-0.315-0.307-0.768,0.203-0.454,0.509 c3.679,3.587,7.359,7.174,11.038,10.761c-0.939,3.903-1.986,7.781-3.15,11.623c-0.669,2.207-1.378,4.4-2.12,6.583 c-3.404-3.728-6.809-7.457-10.213-11.185c-0.296-0.324-0.747,0.188-0.454,0.509c3.472,3.803,6.944,7.606,10.417,11.408 c-0.761,2.208-1.556,4.404-2.391,6.586c-0.155,0.406,0.454,0.713,0.612,0.302c0.795-2.078,1.557-4.169,2.285-6.271 c4.108-1.894,8.216-3.787,12.323-5.681C245.441,469.5,245.234,468.849,244.835,469.033z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M238.809,459.793c-0.26,1.224-0.775,2.354-1.281,3.493c-0.604,1.341-1.209,2.673-1.832,4.006 c-2.287,4.93-4.678,9.825-7.166,14.665c0.069,0.048,0.146,0.086,0.215,0.134c0.481,0.326-1.417,0.263-1.388,0.196 c-1.291-0.838-2.599-1.655-3.939-2.433c-3.313-1.93-6.752-3.665-10.279-5.189c-1.759-0.763-3.549-1.467-5.353-2.134 c-1.565-0.563-3.186-1.13-4.451-2.253c-1.065-0.952-1.755-2.344-1.673-3.787c0.08-1.461,1.081-2.587,2.465-2.992 c1.624-0.476,3.254,0.008,4.825,0.442c1.522,0.412,3.389,0.789,4.688-0.366c1.551-1.373,0.079-3.271-1.035-4.346 c-1.49-1.439-3.08-2.786-4.628-4.173c-1.539-1.388-3.089-2.785-4.628-4.173c-1.196-1.067-2.884-2.303-3.069-4.03 c-0.15-1.475,1.015-2.516,2.383-2.719c1.738-0.259,3.196,0.781,4.794,1.222c0.79,0.221,1.756,0.279,2.457-0.195 c0.71-0.474,0.865-1.386,0.693-2.172c-0.181-0.886-0.768-1.622-1.347-2.285c-0.661-0.746-1.347-1.472-2.025-2.207 c-0.7-0.77-1.398-1.531-2.088-2.292c-0.627-0.686-1.298-1.349-1.832-2.108c-0.813-1.169-1.283-2.648-0.598-3.997 c0.647-1.281,2.003-1.519,3.29-1.175c1.231,0.332,2.848,1.402,4.051,0.475c1.501-1.149,0.926-3.302,0.252-4.714 c-0.859-1.796-1.781-3.502-2.412-5.394c-0.627-1.856-1.076-3.757-1.319-5.697c-0.181-1.426-0.238-2.882,0.197-4.27 c0.383-1.181,1.181-2.231,2.43-2.532c1.623-0.393,3.183,0.655,4.071,1.926c1.07,1.536,1.639,3.453,2.326,5.174 c0.791,1.94,1.574,3.889,2.365,5.828c0.577,1.449,1.527,3.784,3.491,3.502c1.333-0.19,2.029-1.796,3.042-2.53 c1.174-0.86,2.614-0.631,3.597,0.412c1.241,1.327,1.093,3.207,0.73,4.852c-0.905,4.049-2.071,8.043-2.957,12.099 c-0.18,0.841-0.313,1.777,0.123,2.565c0.358,0.649,1.014,0.985,1.739,0.746c1.203-0.396,2.009-1.548,3.21-1.962 c1.325-0.454,2.594,0.257,3.149,1.49c0.735,1.653-0.016,3.53-0.483,5.14c-1.005,3.511-2.01,7.031-3.015,10.542 c1.619-1.334,3.493-2.411,5.66-1.863C238.592,455.319,239.259,457.655,238.809,459.793z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BADDA4"
    },
    d: "M230.271,467.484c-2.109,4.112-5.581,8.612-4.867,13.499c0.281,0.119,0.556,0.236,0.836,0.355 c0.786,0.329-5.934,2.077-8.75,2.322c-2.911,0.253-5.822,0.505-8.733,0.758c-1.434,0.124-2.863,0.249-4.298,0.372 c-1.369,0.119-2.759,0.312-4.138,0.277c-2.263-0.049-4.761-1.093-5.163-3.592c-0.326-2.002,1.319-3.217,2.834-4.108 c0.64-0.379,1.416-0.768,1.834-1.412c0.466-0.713,0.188-1.51-0.366-2.088c-1.674-1.75-4.546-1.178-6.653-0.766 c-2.537,0.496-5.318,1.116-7.773-0.061c-1.841-0.878-3.232-2.997-2.899-5.071c0.315-2.009,2.183-2.895,3.755-3.805 c0.575-0.334,1.345-0.741,1.582-1.407c0.348-0.978-0.576-1.874-1.329-2.322c-2.319-1.395-5.236-0.848-7.797-0.892 c-2.458-0.039-4.976-0.531-6.577-2.563c-1.31-1.66-1.59-4.096-0.048-5.712c1.505-1.568,3.704-1.641,5.657-2.23 c0.937-0.279,2.019-0.722,2.566-1.58c0.616-0.961,0.079-1.994-0.527-2.801c-1.51-2.006-3.384-3.724-4.938-5.696 c-2.76-3.504-5.107-8.718-2.749-13.057c0.995-1.82,2.755-3.282,4.792-3.755c2.198-0.509,4.318,0.284,5.835,1.932 c1.593,1.727,2.593,4.021,3.364,6.217c0.408,1.165,0.73,2.364,0.981,3.572c0.26,1.257,0.37,2.531,0.612,3.789 c0.366,1.879,1.766,4.715,4.157,3.806c1.723-0.659,2.653-2.706,3.448-4.228c0.872-1.651,2.088-3.369,3.849-4.145 c1.926-0.846,4.034,0.054,5.019,1.856c1.239,2.268,0.54,4.861,0.042,7.238c-0.293,1.388-0.587,2.776-0.875,4.165 c-0.232,1.103-0.622,2.296-0.543,3.433c0.076,1.043,0.745,1.706,1.795,1.754c1.08,0.045,2.027-0.499,2.799-1.207 c1.681-1.553,2.823-3.629,5.025-4.55c1.921-0.807,4.044-0.17,5.179,1.575c1.154,1.779,1.224,4.035,0.593,6.009 c-0.771,2.417-2.504,4.653-2.721,7.23c-0.134,1.671,0.49,4.04,2.455,4.285c2.309,0.283,3.953-2.141,5.14-3.733 c1.332-1.802,2.894-3.51,5.248-3.767c2.169-0.238,4.014,1.106,4.293,3.298C232.508,462.995,231.293,465.48,230.271,467.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M226.037,480.886c-4.436-2.406-8.705-5.115-12.774-8.1c0.01-0.032,0.021-0.064,0.021-0.105 c-0.004-1.358-0.008-2.715-0.012-4.073c-0.001-0.436-0.682-0.485-0.681-0.045c0.004,1.241,0.007,2.482,0.011,3.723 c-3.897-2.903-7.613-6.048-11.105-9.427c-0.03-0.029-0.059-0.06-0.089-0.089c0.019-0.035,0.036-0.071,0.042-0.116 c0.235-1.523,0.469-3.047,0.704-4.57c0.067-0.433-0.614-0.477-0.681-0.045c-0.213,1.386-0.427,2.772-0.64,4.158 c-3.058-3.009-5.947-6.189-8.653-9.519c0.055-0.035,0.104-0.081,0.135-0.155c0.862-2.073,1.723-4.146,2.585-6.22 c0.169-0.406-0.476-0.628-0.644-0.224c-0.839,2.02-1.679,4.039-2.518,6.059c-0.147-0.183-0.301-0.361-0.447-0.546 c-3.174-4.006-6.082-8.224-8.689-12.621c-2.585-4.361-4.878-8.896-6.845-13.569c-0.245-0.582-0.484-1.165-0.72-1.751 c-0.164-0.408-0.777-0.109-0.614,0.297c1.907,4.749,4.142,9.364,6.683,13.806c2.532,4.426,5.362,8.682,8.46,12.732 c0.486,0.636,0.991,1.257,1.49,1.882c-2.258,0.069-4.516,0.137-6.773,0.206c-0.434,0.013-0.485,0.694-0.045,0.681 c2.448-0.074,4.896-0.149,7.344-0.223c2.541,3.135,5.241,6.141,8.097,8.993c0.147,0.147,0.3,0.287,0.448,0.432 c-1.558,0.161-3.116,0.322-4.674,0.484c-0.436,0.045-0.303,0.714,0.132,0.669l5.181-0.536c3.294,3.205,6.77,6.226,10.424,9.013 c0.241,0.184,0.489,0.357,0.731,0.538l-4.352,1.646c-0.172,0.065-0.234,0.3-0.158,0.456c0.086,0.178,0.283,0.224,0.456,0.158 c1.569-0.594,3.138-1.187,4.707-1.781c3.655,2.7,7.463,5.193,11.421,7.426c0.55,0.31,1.102,0.615,1.657,0.916 C226.032,481.655,226.423,481.095,226.037,480.886z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BADDA4"
    },
    d: "M257.158,440.215c0.493,0.675,1.144,1.659,0.761,2.519c-0.353,0.805-1.441,1.087-2.154,1.45 c-1.687,0.86-2.56,2.45-2.589,4.325c-0.026,1.925,0.992,3.644,2.361,4.938c1.563,1.478,3.539,2.386,5.391,3.438 c1.503,0.853,3.649,2.119,3.782,4.081c0.14,2.041-2.979,1.679-4.266,1.993c-1.702,0.414-2.828,1.808-2.992,3.54 c-0.415,4.379,3.962,6.297,7.288,7.781l13.309,5.921c0.006-0.001,0.006,0.005,0.007,0.01c0.204,0.353,0.523,0.438,0.822,0.356 c0,0,1.801-1.037,0.812-1.473c-0.14-0.063-0.281-0.125-0.421-0.188c-0.723-1.539-0.646-3.325-0.108-4.919 c1.421-4.218,5.504-6.47,9.084-8.636c1.736-1.049,3.557-2.1,4.656-3.874c0.895-1.453,0.884-3.361-0.477-4.531 c-1.124-0.965-2.696-1.013-4.097-1.129c-1.372-0.109-3.182-0.227-3.742-1.741c-0.654-1.782,0.504-3.646,1.721-4.861 c1.471-1.466,3.304-2.587,4.466-4.348c0.999-1.514,1.6-3.6,0.81-5.344c-0.645-1.41-1.983-2.227-3.478-2.464 c-1.506-0.235-3.031-0.03-4.547-0.008c-1.317,0.024-2.885-0.071-3.72-1.252c-1.168-1.666-0.263-3.976,0.436-5.63 c0.783-1.837,1.687-3.835,1.23-5.87c-0.354-1.575-1.542-3.187-3.216-3.48c-1.038-0.18-1.881,0.25-2.798,0.681 c-0.838,0.395-1.685,0.485-2.568,0.173c-4.725-1.652-3.584-7.972-3.779-11.807c-0.102-2.086-0.52-4.377-1.875-6.042 c-1.136-1.394-2.838-2.328-4.653-2.372c-1.849-0.044-3.434,1.1-4.195,2.752c-0.853,1.859-0.848,4.046-0.832,6.056 c0.021,2.428,0.283,4.846,0.771,7.221c0.248,1.196,0.664,2.41,0.68,3.643c0.01,0.877-0.337,2.072-1.305,2.329 c-0.707,0.187-1.404-0.24-1.982-0.589c-0.702-0.42-1.364-0.909-2.126-1.207c-1.752-0.677-3.543-0.078-4.63,1.45 c-1.284,1.821-1.11,4.071-0.214,6.025c0.981,2.161,2.486,4.124,3.95,5.976c0.733,0.931,1.495,1.829,2.288,2.711 C255.734,438.612,256.521,439.353,257.158,440.215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M262.994,466.252c3.938,1.815,7.876,3.631,11.813,5.446c-2.006-5.872-3.755-11.832-5.226-17.861 c-0.067-0.275-0.129-0.551-0.195-0.826c-0.019-0.006-0.037-0.006-0.056-0.016c-3.768-1.949-7.536-3.897-11.303-5.846 c-0.39-0.202-0.016-0.773,0.371-0.573c3.596,1.86,7.191,3.719,10.787,5.579c-1.269-5.392-2.307-10.838-3.143-16.314 c-3.769-2.894-7.538-5.788-11.307-8.682c-0.346-0.266,0.022-0.841,0.371-0.573c3.594,2.759,7.187,5.519,10.781,8.278 c-0.331-2.242-0.634-4.488-0.891-6.74c-0.556-4.876-0.937-9.772-1.147-14.676c-0.019-0.439,0.662-0.396,0.681,0.039 c0.306,7.132,0.995,14.245,2.038,21.307c3.547-3.069,7.094-6.137,10.641-9.206c0.332-0.287,0.786,0.222,0.454,0.509 c-3.653,3.16-7.306,6.321-10.959,9.481c0.029,0.08,0.037,0.162,0.008,0.24c0.181,1.186,0.37,2.371,0.572,3.554 c0.737,4.321,1.612,8.619,2.621,12.885c3.591-3.5,7.181-7.001,10.772-10.501c0.315-0.307,0.768,0.203,0.454,0.509 c-3.679,3.587-7.359,7.174-11.038,10.761c0.939,3.903,1.986,7.781,3.15,11.623c0.668,2.207,1.378,4.4,2.12,6.583 c3.404-3.728,6.809-7.457,10.213-11.185c0.296-0.324,0.747,0.188,0.454,0.509c-3.472,3.803-6.944,7.606-10.417,11.408 c0.761,2.208,1.556,4.404,2.391,6.586c0.155,0.406-0.454,0.713-0.612,0.302c-0.795-2.078-1.557-4.169-2.285-6.271 c-4.108-1.894-8.216-3.787-12.323-5.681C262.389,466.719,262.596,466.069,262.994,466.252z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M269.021,457.013c0.26,1.224,0.775,2.354,1.281,3.493c0.604,1.341,1.209,2.673,1.832,4.006 c2.287,4.93,4.678,9.825,7.166,14.665c-0.069,0.048-0.146,0.086-0.215,0.134c-0.481,0.326,1.417,0.263,1.388,0.196 c1.291-0.838,2.599-1.655,3.939-2.433c3.313-1.93,6.752-3.665,10.279-5.189c1.759-0.763,3.549-1.467,5.353-2.134 c1.565-0.563,3.186-1.13,4.451-2.253c1.065-0.952,1.755-2.344,1.673-3.787c-0.08-1.461-1.081-2.587-2.465-2.992 c-1.624-0.476-3.254,0.008-4.825,0.442c-1.522,0.412-3.389,0.789-4.688-0.366c-1.551-1.373-0.079-3.271,1.035-4.346 c1.49-1.439,3.08-2.786,4.628-4.173c1.539-1.388,3.089-2.785,4.628-4.173c1.196-1.067,2.884-2.303,3.069-4.03 c0.15-1.475-1.015-2.516-2.383-2.719c-1.738-0.259-3.196,0.781-4.794,1.222c-0.79,0.221-1.756,0.279-2.457-0.195 c-0.71-0.474-0.865-1.386-0.693-2.172c0.181-0.886,0.768-1.622,1.347-2.285c0.661-0.746,1.347-1.472,2.025-2.207 c0.7-0.77,1.398-1.531,2.088-2.292c0.627-0.686,1.298-1.349,1.832-2.108c0.813-1.169,1.283-2.648,0.598-3.997 c-0.647-1.281-2.003-1.519-3.29-1.175c-1.231,0.332-2.848,1.402-4.051,0.475c-1.501-1.149-0.926-3.302-0.252-4.714 c0.859-1.796,1.781-3.502,2.412-5.394c0.627-1.856,1.076-3.757,1.319-5.697c0.181-1.426,0.238-2.882-0.197-4.27 c-0.383-1.181-1.181-2.231-2.43-2.532c-1.623-0.393-3.183,0.655-4.071,1.926c-1.07,1.536-1.639,3.453-2.326,5.174 c-0.791,1.94-1.574,3.889-2.365,5.828c-0.577,1.449-1.527,3.784-3.491,3.502c-1.333-0.19-2.029-1.796-3.042-2.53 c-1.174-0.86-2.614-0.631-3.597,0.412c-1.241,1.327-1.093,3.207-0.73,4.852c0.905,4.049,2.071,8.043,2.957,12.099 c0.18,0.841,0.313,1.777-0.123,2.565c-0.358,0.649-1.014,0.985-1.739,0.746c-1.203-0.396-2.009-1.547-3.21-1.962 c-1.325-0.454-2.594,0.257-3.149,1.49c-0.734,1.653,0.016,3.53,0.483,5.14c1.005,3.511,2.009,7.031,3.015,10.542 c-1.619-1.334-3.493-2.411-5.66-1.863C269.238,452.538,268.571,454.874,269.021,457.013z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BADDA4"
    },
    d: "M277.559,464.703c2.109,4.112,5.581,8.612,4.867,13.499c-0.281,0.119-0.556,0.236-0.836,0.355 c-0.786,0.329,5.934,2.077,8.75,2.322c2.911,0.253,5.822,0.505,8.733,0.758c1.434,0.124,2.863,0.249,4.298,0.372 c1.369,0.118,2.759,0.312,4.138,0.277c2.263-0.049,4.761-1.093,5.163-3.592c0.326-2.002-1.319-3.217-2.834-4.108 c-0.64-0.379-1.416-0.768-1.834-1.412c-0.466-0.713-0.188-1.51,0.366-2.088c1.674-1.75,4.546-1.178,6.653-0.766 c2.537,0.496,5.318,1.116,7.773-0.061c1.841-0.878,3.232-2.997,2.899-5.071c-0.315-2.009-2.183-2.895-3.755-3.805 c-0.575-0.334-1.345-0.741-1.582-1.407c-0.348-0.978,0.576-1.874,1.329-2.322c2.319-1.395,5.236-0.848,7.797-0.892 c2.458-0.039,4.976-0.531,6.577-2.563c1.31-1.66,1.59-4.096,0.048-5.712c-1.505-1.568-3.704-1.641-5.657-2.23 c-0.938-0.279-2.019-0.722-2.566-1.58c-0.616-0.961-0.079-1.994,0.527-2.801c1.51-2.006,3.384-3.724,4.938-5.696 c2.76-3.504,5.107-8.718,2.749-13.057c-0.995-1.82-2.755-3.282-4.792-3.755c-2.198-0.509-4.318,0.284-5.835,1.932 c-1.593,1.727-2.593,4.021-3.364,6.217c-0.408,1.165-0.73,2.364-0.981,3.572c-0.26,1.257-0.37,2.531-0.612,3.789 c-0.366,1.879-1.766,4.715-4.157,3.806c-1.723-0.659-2.653-2.706-3.448-4.228c-0.872-1.651-2.088-3.369-3.849-4.145 c-1.926-0.846-4.034,0.054-5.019,1.856c-1.239,2.268-0.54,4.861-0.042,7.238c0.293,1.388,0.587,2.776,0.875,4.165 c0.232,1.103,0.622,2.296,0.543,3.433c-0.076,1.043-0.745,1.706-1.795,1.754c-1.08,0.045-2.027-0.499-2.799-1.207 c-1.681-1.553-2.823-3.629-5.025-4.55c-1.921-0.807-4.044-0.17-5.179,1.575c-1.154,1.779-1.224,4.035-0.593,6.009 c0.771,2.417,2.504,4.653,2.721,7.23c0.134,1.671-0.49,4.04-2.455,4.285c-2.309,0.283-3.953-2.141-5.14-3.733 c-1.332-1.802-2.894-3.51-5.248-3.767c-2.169-0.238-4.014,1.106-4.293,3.298C275.322,460.214,276.536,462.699,277.559,464.703z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M281.793,478.105c4.436-2.406,8.705-5.115,12.774-8.1c-0.01-0.032-0.021-0.064-0.021-0.105 c0.004-1.358,0.008-2.715,0.012-4.073c0.001-0.436,0.682-0.485,0.681-0.045c-0.004,1.241-0.007,2.482-0.011,3.723 c3.897-2.903,7.613-6.048,11.105-9.427c0.03-0.029,0.059-0.06,0.089-0.089c-0.019-0.035-0.036-0.071-0.042-0.116 c-0.234-1.523-0.469-3.047-0.704-4.57c-0.067-0.433,0.614-0.477,0.681-0.045c0.213,1.386,0.427,2.772,0.64,4.158 c3.058-3.009,5.947-6.189,8.653-9.519c-0.055-0.035-0.104-0.081-0.135-0.155c-0.862-2.073-1.723-4.146-2.585-6.22 c-0.169-0.406,0.476-0.628,0.644-0.224c0.839,2.02,1.679,4.039,2.518,6.059c0.147-0.184,0.301-0.361,0.447-0.546 c3.174-4.006,6.082-8.224,8.689-12.621c2.585-4.361,4.878-8.896,6.845-13.569c0.245-0.582,0.484-1.165,0.72-1.751 c0.164-0.408,0.777-0.109,0.614,0.297c-1.907,4.749-4.142,9.364-6.683,13.806c-2.532,4.426-5.362,8.682-8.46,12.732 c-0.486,0.636-0.991,1.257-1.49,1.882c2.258,0.069,4.516,0.137,6.773,0.206c0.434,0.013,0.485,0.694,0.045,0.681 c-2.448-0.074-4.896-0.149-7.344-0.223c-2.541,3.135-5.241,6.142-8.097,8.993c-0.147,0.147-0.3,0.287-0.448,0.432 c1.558,0.161,3.116,0.322,4.674,0.484c0.436,0.045,0.303,0.714-0.132,0.669l-5.181-0.536c-3.294,3.205-6.77,6.226-10.424,9.013 c-0.241,0.183-0.489,0.357-0.731,0.538l4.352,1.646c0.172,0.065,0.234,0.3,0.158,0.456c-0.086,0.178-0.283,0.224-0.456,0.158 c-1.569-0.594-3.138-1.187-4.707-1.781c-3.655,2.7-7.463,5.193-11.421,7.426c-0.55,0.31-1.102,0.615-1.657,0.916 C281.797,478.874,281.407,478.314,281.793,478.105z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M339.53,488.663H195.949c0,0,21.225-22.165,61.504-22.165S339.53,488.663,339.53,488.663z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#88D159"
    },
    points: "198.57,68.191 198.57,76.432 188.957,76.432 188.957,86.046 180.715,86.046  180.715,76.432 171.102,76.432 171.102,68.191 180.715,68.191 180.715,58.577 188.957,58.577 188.957,68.191  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#88D159"
    },
    points: "221.99,51.638 221.99,56.778 215.994,56.778 215.994,62.773 210.854,62.773  210.854,56.778 204.859,56.778 204.859,51.638 210.854,51.638 210.854,45.642 215.994,45.642 215.994,51.638  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#518AFC"
    },
    points: "202.832,37.932 202.832,43.072 196.837,43.072 196.837,49.068 191.697,49.068  191.697,43.072 185.701,43.072 185.701,37.932 191.697,37.932 191.697,31.937 196.837,31.937 196.837,37.932  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#518AFC"
    },
    d: "M175.513,41.675c-4.504,0-3.867,6.973,0.61,6.973C180.628,48.649,179.991,41.675,175.513,41.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#518AFC"
    },
    d: "M158.278,71.143c-4.504,0-3.867,6.973,0.61,6.973C163.392,78.116,162.755,71.143,158.278,71.143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41E0E0"
    },
    d: "M161.745,56.513c-2.574,0-2.21,3.985,0.349,3.985C164.667,60.498,164.303,56.513,161.745,56.513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41E0E0"
    },
    d: "M163.969,38.166c-2.574,0-2.21,3.985,0.349,3.985C166.891,42.151,166.527,38.166,163.969,38.166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41E0E0"
    },
    d: "M208.447,72.637c-2.574,0-2.21,3.985,0.349,3.985C211.37,76.622,211.006,72.637,208.447,72.637z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#88D159"
    },
    points: "328.832,388.299 328.832,396.541 319.219,396.541 319.219,406.154 310.977,406.154  310.977,396.541 301.364,396.541 301.364,388.299 310.977,388.299 310.977,378.686 319.219,378.686 319.219,388.299  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#88D159"
    },
    points: "352.252,371.746 352.252,376.886 346.257,376.886 346.257,382.882 341.116,382.882  341.116,376.886 335.121,376.886 335.121,371.746 341.116,371.746 341.116,365.751 346.257,365.751 346.257,371.746  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#518AFC"
    },
    points: "333.094,358.04 333.094,363.181 327.099,363.181 327.099,369.176 321.959,369.176  321.959,363.181 315.963,363.181 315.963,358.04 321.959,358.04 321.959,352.045 327.099,352.045 327.099,358.04  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#518AFC"
    },
    d: "M340.085,390.736c-4.504,0-3.867,6.973,0.61,6.973 C345.199,397.709,344.562,390.736,340.085,390.736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#518AFC"
    },
    d: "M291.158,383.508c-4.504,0-3.867,6.973,0.61,6.973 C296.272,390.481,295.636,383.508,291.158,383.508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41E0E0"
    },
    d: "M296.849,371.103c-2.574,0-2.21,3.985,0.349,3.985 C299.771,375.088,299.407,371.103,296.849,371.103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41E0E0"
    },
    d: "M304.633,364.431c-2.574,0-2.21,3.985,0.349,3.985 C307.555,368.416,307.191,364.431,304.633,364.431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41E0E0"
    },
    d: "M294.069,359.983c-2.574,0-2.21,3.985,0.349,3.985 C296.991,363.968,296.628,359.983,294.069,359.983z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41E0E0"
    },
    d: "M338.548,344.971c-2.574,0-2.21,3.985,0.349,3.985 C341.47,348.956,341.106,344.971,338.548,344.971z"
  }))), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#3B4148",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "6.992,6.992"
    },
    cx: 241.287,
    cy: 219.52,
    r: 116.173
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#518AFC"
    },
    d: "M282.423,255.852c-39.435,21.272-70.749,8.129-70.749,8.129c-3.618-4.511,1.036-5.762,1.036-5.762 l3.395-19.797l-11.373-46.226c2.08-12.409,21.71-42.233,24.133-45.867c0.654,0.797,1.387,1.578,2.2,2.303 c-0.454,4.073-2.008,20.722,2.917,22.73c4.742,1.937,13.812,1.132,16.506,0.837c-0.064,0.191-0.135,0.383-0.191,0.574 c-0.789,2.598-0.247,5.499,1.164,7.811c1.419,2.319,3.65,4.073,6.121,5.188c2.072,0.932,4.415,1.451,6.631,0.94 c2.216-0.51,4.232-2.216,4.654-4.455c0.335-1.801-0.375-3.626-1.211-5.26c-0.845-1.626-1.841-3.228-2.16-5.037 c-0.359-2.064,0.215-4.081,0.885-6.105c5.611,8.241,6.934,13.78,6.934,13.78l-4.917,47.708l11.811,23.782 C284.638,251.796,282.423,255.852,282.423,255.852z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M221.067,180.293c-0.949-1.999-1.897-3.999-2.846-5.999c-0.267-0.563-0.907-0.97-1.538-0.704 c-0.554,0.234-0.991,0.933-0.704,1.538c0.949,1.999,1.897,3.999,2.846,5.999c0.267,0.563,0.907,0.97,1.538,0.704 C220.918,181.597,221.354,180.898,221.067,180.293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M227.477,167.401c-0.396-0.51-1.122-0.674-1.667-0.285c-1.334,0.954-2.668,1.907-4.002,2.861 c-0.509,0.364-0.682,1.155-0.285,1.667c0.396,0.51,1.122,0.674,1.667,0.285c1.334-0.954,2.668-1.907,4.002-2.861 C227.701,168.704,227.874,167.912,227.477,167.401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M226.441,156.568c-0.225-0.189-0.577-0.314-0.873-0.275c-0.307,0.041-0.617,0.17-0.812,0.422 c-0.207,0.269-0.26,0.537-0.275,0.873c-0.074,1.625-0.147,3.25-0.221,4.874c-0.013,0.282,0.217,0.639,0.422,0.812 c0.225,0.189,0.577,0.314,0.873,0.275c0.307-0.041,0.617-0.17,0.812-0.422c0.207-0.269,0.26-0.536,0.275-0.873 c0.074-1.625,0.147-3.25,0.221-4.874C226.876,157.097,226.646,156.74,226.441,156.568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M229.469,181.751c-0.221-1.994-0.442-3.988-0.662-5.982c-0.069-0.621-0.644-1.173-1.295-1.087 c-0.63,0.084-1.161,0.629-1.087,1.295c0.221,1.994,0.442,3.988,0.662,5.982c0.069,0.621,0.644,1.173,1.295,1.087 C229.013,182.962,229.543,182.417,229.469,181.751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M240.118,177.405c-0.091-0.685-0.624-1.092-1.295-1.087c-1.92,0.015-3.84,0.029-5.76,0.044 c-0.627,0.005-1.167,0.69-1.087,1.295c0.091,0.685,0.624,1.092,1.295,1.087l5.76-0.044 C239.658,178.696,240.198,178.011,240.118,177.405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M248.294,184.958c-0.727-1.556-1.453-3.113-2.18-4.669c-0.264-0.565-0.91-0.969-1.538-0.704 c-0.557,0.236-0.987,0.931-0.704,1.538c0.727,1.556,1.453,3.113,2.18,4.669c0.264,0.565,0.91,0.969,1.538,0.704 C248.147,186.261,248.577,185.565,248.294,184.958z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M239.933,183.306c-0.019-0.626-0.68-1.168-1.295-1.087c-0.673,0.089-1.107,0.624-1.087,1.295 l0.177,5.762c0.019,0.626,0.68,1.168,1.295,1.087c0.673-0.089,1.107-0.624,1.087-1.295 C240.052,187.148,239.993,185.227,239.933,183.306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M227.013,194.828c-0.447-2.067-0.894-4.134-1.341-6.201c-0.132-0.609-0.599-1.179-1.295-1.087 c-0.576,0.076-1.228,0.64-1.087,1.295c0.447,2.067,0.894,4.134,1.341,6.201c0.132,0.609,0.599,1.179,1.295,1.087 C226.502,196.047,227.155,195.483,227.013,194.828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M218.182,187.551c-0.094-0.704-0.623-1.067-1.295-1.087c-1.994-0.057-3.989-0.115-5.983-0.172 c-0.627-0.018-1.165,0.706-1.087,1.295c0.094,0.704,0.623,1.067,1.295,1.087c1.994,0.057,3.989,0.115,5.984,0.172 C217.723,188.864,218.26,188.14,218.182,187.551z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M218.83,195.562c-0.166-0.234-0.47-0.445-0.76-0.485c-0.584-0.08-1.344,0.293-1.392,0.96 l-0.371,5.101c-0.024,0.331,0.001,0.627,0.2,0.907c0.166,0.234,0.47,0.445,0.76,0.485c0.584,0.08,1.344-0.293,1.392-0.96 l0.371-5.101C219.054,196.138,219.029,195.843,218.83,195.562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M211.14,200.577c-0.061-0.622-0.65-1.172-1.295-1.087c-0.637,0.085-1.152,0.628-1.087,1.295 c0.195,1.997,0.39,3.993,0.585,5.99c0.061,0.622,0.65,1.172,1.295,1.087c0.637-0.085,1.152-0.628,1.087-1.295L211.14,200.577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M230.274,201.309c-0.255-0.602-0.907-0.93-1.538-0.704c-2.067,0.741-4.134,1.482-6.201,2.223 c-0.589,0.211-0.953,0.948-0.704,1.538c0.255,0.602,0.907,0.93,1.538,0.704c2.067-0.741,4.134-1.482,6.201-2.223 C230.16,202.636,230.524,201.899,230.274,201.309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M241.535,202.535l-5.027-4.93c-0.445-0.436-1.148-0.657-1.679-0.197 c-0.439,0.38-0.675,1.21-0.197,1.679l5.027,4.93c0.445,0.436,1.148,0.657,1.679,0.197 C241.778,203.834,242.013,203.004,241.535,202.535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M248.54,204.126c-0.375-2.067-0.751-4.134-1.126-6.2c-0.111-0.614-0.614-1.177-1.295-1.087 c-0.594,0.079-1.206,0.636-1.087,1.295c0.375,2.067,0.751,4.134,1.126,6.2c0.111,0.614,0.614,1.177,1.295,1.087 C248.047,205.342,248.66,204.785,248.54,204.126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M257.407,193.801c-0.085-0.642-0.628-1.146-1.295-1.087c-1.991,0.178-3.983,0.357-5.974,0.535 c-0.623,0.056-1.172,0.654-1.087,1.295c0.085,0.642,0.628,1.147,1.295,1.087c1.991-0.178,3.983-0.357,5.974-0.535 C256.943,195.04,257.492,194.443,257.407,193.801z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M264.744,196.811c-0.295-2.142-0.59-4.284-0.885-6.425c-0.085-0.619-0.632-1.175-1.295-1.087 c-0.616,0.082-1.178,0.632-1.087,1.295l0.885,6.425c0.085,0.619,0.632,1.175,1.295,1.087 C264.274,198.024,264.836,197.474,264.744,196.811z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M272.062,184.757c-0.403-0.519-1.113-0.661-1.667-0.285c-1.321,0.899-2.642,1.797-3.963,2.696 c-0.517,0.352-0.675,1.163-0.285,1.667c0.403,0.519,1.113,0.661,1.667,0.285c1.321-0.899,2.642-1.797,3.963-2.696 C272.295,186.072,272.453,185.261,272.062,184.757z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M269.719,205.37c-0.592-1.846-1.185-3.692-1.777-5.537c-0.191-0.596-0.962-0.947-1.538-0.704 c-0.619,0.262-0.909,0.899-0.704,1.538c0.593,1.846,1.185,3.692,1.778,5.537c0.191,0.596,0.962,0.947,1.538,0.704 C269.634,206.646,269.924,206.009,269.719,205.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M259.384,199.969c-0.498-0.383-1.274-0.38-1.684,0.147c-1.55,1.995-3.1,3.989-4.651,5.984 c-0.384,0.494-0.378,1.281,0.147,1.684c0.498,0.383,1.274,0.38,1.684-0.147c1.55-1.995,3.1-3.989,4.651-5.984 C259.915,201.159,259.909,200.372,259.384,199.969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M247.909,218.14c-1.402-1.921-2.805-3.842-4.207-5.763c-0.369-0.505-1.152-0.684-1.667-0.285 c-0.506,0.392-0.679,1.126-0.285,1.667c1.402,1.921,2.805,3.842,4.207,5.762c0.369,0.505,1.152,0.684,1.667,0.285 C248.13,219.414,248.304,218.68,247.909,218.14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M233.935,213.051c-0.671-0.092-1.236,0.308-1.392,0.96c-0.459,1.917-0.917,3.833-1.375,5.75 c-0.146,0.609,0.344,1.307,0.96,1.392c0.671,0.092,1.236-0.308,1.392-0.96c0.458-1.916,0.917-3.833,1.375-5.749 C235.04,213.835,234.551,213.136,233.935,213.051z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M222.466,218.622c-0.461-1.842-0.922-3.684-1.383-5.526c-0.152-0.609-0.989-0.936-1.538-0.704 c-0.651,0.275-0.867,0.886-0.704,1.538c0.461,1.842,0.922,3.684,1.383,5.526c0.152,0.609,0.989,0.936,1.538,0.704 C222.413,219.885,222.629,219.274,222.466,218.622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M221.741,226.133c-1.478-1.697-2.957-3.395-4.435-5.092c-0.211-0.242-0.433-0.425-0.76-0.485 c-0.292-0.054-0.668,0.015-0.907,0.2c-0.47,0.364-0.724,1.162-0.285,1.667c1.478,1.697,2.957,3.395,4.435,5.092 c0.21,0.242,0.433,0.425,0.76,0.485c0.292,0.054,0.668-0.015,0.907-0.2C221.925,227.436,222.18,226.638,221.741,226.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M233.848,227.094c-0.266-0.63-0.894-0.894-1.538-0.704c-1.77,0.525-3.54,1.049-5.311,1.574 c-0.601,0.178-0.943,0.971-0.704,1.538c0.266,0.63,0.894,0.894,1.538,0.704c1.77-0.525,3.54-1.049,5.311-1.574 C233.745,228.454,234.088,227.661,233.848,227.094z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M245.123,229.746l-2.223-4.427c-0.145-0.288-0.307-0.521-0.61-0.664 c-0.268-0.127-0.65-0.157-0.928-0.04c-0.543,0.23-1.004,0.939-0.704,1.538l2.223,4.427c0.145,0.288,0.307,0.521,0.61,0.664 c0.268,0.127,0.65,0.157,0.928,0.04C244.963,231.054,245.424,230.344,245.123,229.746z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M214.831,208.602c-0.619-0.085-1.3,0.298-1.392,0.96c-0.227,1.624-0.453,3.248-0.68,4.872 c-0.086,0.618,0.302,1.302,0.96,1.392c0.619,0.085,1.3-0.298,1.392-0.96c0.227-1.624,0.453-3.248,0.68-4.872 C215.877,209.376,215.49,208.693,214.831,208.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M252.87,228.635c-0.442-1.699-0.885-3.398-1.327-5.096c-0.158-0.607-0.985-0.938-1.538-0.704 c-0.646,0.273-0.873,0.888-0.704,1.538l1.327,5.096c0.158,0.607,0.985,0.938,1.538,0.704 C252.813,229.9,253.04,229.286,252.87,228.635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M260.839,215.708c-0.232-0.548-0.937-0.998-1.538-0.704c-1.483,0.727-2.965,1.454-4.448,2.181 c-0.288,0.141-0.522,0.31-0.664,0.61c-0.127,0.268-0.157,0.65-0.04,0.928c0.232,0.548,0.937,0.998,1.538,0.704 c1.483-0.727,2.965-1.454,4.448-2.181c0.288-0.141,0.522-0.31,0.664-0.61C260.927,216.368,260.957,215.986,260.839,215.708z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M267.538,217.102c-0.444-1.403-0.888-2.806-1.332-4.209c-0.189-0.597-0.964-0.947-1.538-0.704 c-0.621,0.263-0.906,0.898-0.704,1.538c0.444,1.403,0.888,2.806,1.332,4.209c0.189,0.597,0.964,0.947,1.538,0.704 C267.455,218.377,267.74,217.741,267.538,217.102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M264.474,222.647c-0.598-0.252-1.306-0.034-1.592,0.57l-1.994,4.21 c-0.268,0.566-0.025,1.342,0.57,1.592c0.598,0.252,1.306,0.034,1.592-0.57l1.994-4.21 C265.311,223.674,265.068,222.898,264.474,222.647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M257.336,233.599c-0.051-0.623-0.657-1.171-1.295-1.087c-0.646,0.086-1.141,0.627-1.087,1.295 c0.145,1.773,0.289,3.545,0.434,5.318c0.051,0.623,0.657,1.172,1.295,1.087c0.646-0.086,1.141-0.627,1.087-1.295 C257.625,237.145,257.48,235.372,257.336,233.599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M267.59,236.247c-0.088-0.663-0.625-1.12-1.295-1.087c-1.477,0.074-2.954,0.147-4.431,0.221 c-0.625,0.031-1.17,0.671-1.087,1.295c0.088,0.663,0.625,1.12,1.295,1.087c1.477-0.074,2.954-0.147,4.431-0.221 C267.129,237.51,267.673,236.871,267.59,236.247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M273.023,244.371c-0.515-1.552-1.029-3.103-1.544-4.655c-0.197-0.594-0.958-0.949-1.538-0.704 c-0.614,0.26-0.915,0.901-0.704,1.538c0.514,1.552,1.029,3.103,1.544,4.655c0.197,0.594,0.958,0.949,1.538,0.704 C272.933,245.649,273.234,245.008,273.023,244.371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M265.326,243.012c-0.627-0.264-1.27-0.017-1.592,0.57c-0.81,1.478-1.621,2.956-2.431,4.434 c-0.301,0.55-0.001,1.352,0.57,1.592c0.627,0.264,1.27,0.017,1.592-0.57c0.81-1.478,1.621-2.956,2.431-4.434 C266.197,244.054,265.896,243.252,265.326,243.012z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M273.259,251.175c-2.218-0.199-4.435-0.397-6.653-0.596c-0.621-0.056-1.299,0.28-1.392,0.96 c-0.082,0.593,0.294,1.333,0.96,1.392c2.218,0.199,4.435,0.397,6.653,0.596c0.621,0.056,1.299-0.28,1.392-0.96 C274.3,251.975,273.925,251.235,273.259,251.175z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M277.935,249.586c-0.663-0.091-1.246,0.306-1.392,0.96c-0.446,1.993-0.891,3.987-1.337,5.98 c-0.136,0.61,0.337,1.307,0.96,1.392c0.663,0.091,1.246-0.306,1.392-0.96c0.446-1.994,0.891-3.987,1.337-5.98 C279.031,250.368,278.557,249.672,277.935,249.586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M267.052,258.078c-1.551-0.145-3.102-0.291-4.653-0.436c-0.326-0.031-0.632,0.005-0.907,0.2 c-0.234,0.166-0.445,0.47-0.485,0.76c-0.082,0.595,0.294,1.33,0.96,1.392l4.653,0.436c0.326,0.031,0.632-0.005,0.907-0.2 c0.234-0.166,0.445-0.47,0.485-0.76C268.094,258.875,267.718,258.14,267.052,258.078z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M256.672,254.181c-0.573-0.241-1.336-0.047-1.592,0.57c-0.762,1.837-1.524,3.673-2.285,5.51 c-0.239,0.577-0.045,1.333,0.57,1.592c0.573,0.242,1.336,0.047,1.592-0.57c0.762-1.837,1.524-3.673,2.285-5.51 C257.481,255.196,257.286,254.44,256.672,254.181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M254.323,245.169c-0.629-0.086-1.288,0.299-1.392,0.96l-0.665,4.21 c-0.097,0.617,0.309,1.303,0.96,1.392c0.629,0.087,1.288-0.299,1.392-0.96c0.222-1.403,0.443-2.806,0.665-4.21 C255.38,245.944,254.973,245.258,254.323,245.169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M250.78,233.896c-0.518-0.398-1.249-0.36-1.684,0.147c-1.329,1.551-2.659,3.102-3.988,4.653 c-0.408,0.476-0.361,1.293,0.147,1.684c0.518,0.398,1.249,0.36,1.684-0.147c1.329-1.551,2.659-3.102,3.988-4.653 C251.335,235.105,251.288,234.287,250.78,233.896z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M237.985,234.252c-0.049-0.624-0.658-1.171-1.295-1.087c-0.647,0.086-1.139,0.627-1.087,1.295 c0.146,1.846,0.291,3.693,0.437,5.539c0.049,0.624,0.658,1.171,1.295,1.087c0.647-0.086,1.139-0.627,1.087-1.295 C238.276,237.945,238.13,236.099,237.985,234.252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M231.242,238.576c-1.328-1.331-2.655-2.662-3.983-3.993c-0.205-0.206-0.594-0.3-0.873-0.275 c-0.292,0.026-0.63,0.186-0.812,0.422c-0.424,0.551-0.326,1.21,0.147,1.684c1.328,1.331,2.655,2.662,3.983,3.993 c0.205,0.205,0.594,0.299,0.873,0.275c0.292-0.026,0.63-0.186,0.812-0.423C231.813,239.709,231.715,239.05,231.242,238.576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M220.861,241.345c-0.366-2.29-0.732-4.58-1.099-6.87c-0.099-0.616-0.623-1.176-1.295-1.087 c-0.605,0.08-1.193,0.634-1.087,1.295c0.366,2.29,0.732,4.58,1.099,6.87c0.099,0.616,0.623,1.176,1.295,1.087 C220.379,242.56,220.967,242.007,220.861,241.345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M231.477,245.793c-0.091-0.682-0.624-1.095-1.295-1.087l-6.646,0.084 c-0.627,0.008-1.167,0.688-1.087,1.295c0.091,0.682,0.624,1.095,1.295,1.087l6.646-0.084 C231.017,247.08,231.557,246.4,231.477,245.793z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M238.246,244.263c-0.637-0.088-1.277,0.301-1.392,0.96c-0.296,1.698-0.592,3.397-0.888,5.095 c-0.107,0.615,0.316,1.304,0.96,1.392c0.637,0.088,1.277-0.301,1.392-0.96l0.888-5.095 C239.313,245.04,238.89,244.351,238.246,244.263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M250.296,248.786c-1.551-0.739-3.101-1.479-4.652-2.218c-0.565-0.269-1.342-0.024-1.592,0.57 c-0.252,0.599-0.033,1.305,0.57,1.592c1.551,0.739,3.101,1.479,4.652,2.218c0.565,0.269,1.342,0.024,1.592-0.57 C251.118,249.779,250.899,249.074,250.296,248.786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M246.897,254.013c-0.664-0.091-1.244,0.307-1.392,0.96c-0.369,1.625-0.739,3.249-1.108,4.874 c-0.139,0.61,0.339,1.307,0.96,1.392c0.665,0.091,1.244-0.307,1.392-0.96c0.369-1.625,0.739-3.25,1.108-4.874 C247.996,254.795,247.518,254.099,246.897,254.013z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M238.766,253.356c-0.603-0.083-1.32,0.295-1.392,0.96c-0.152,1.403-0.305,2.805-0.457,4.208 c-0.067,0.62,0.288,1.3,0.96,1.392c0.603,0.083,1.32-0.295,1.392-0.96c0.152-1.403,0.305-2.805,0.457-4.208 C239.793,254.128,239.437,253.448,238.766,253.356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M229.551,255.018c-0.044-0.331-0.189-0.575-0.422-0.812c-1.358-1.375-2.715-2.751-4.073-4.126 c-0.203-0.206-0.596-0.299-0.873-0.275c-0.292,0.026-0.63,0.186-0.812,0.423c-0.189,0.245-0.317,0.557-0.275,0.873 c0.044,0.331,0.189,0.575,0.422,0.812c1.358,1.375,2.715,2.751,4.073,4.126c0.203,0.206,0.596,0.299,0.873,0.275 c0.292-0.026,0.63-0.186,0.812-0.423C229.464,255.645,229.593,255.334,229.551,255.018z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M219.72,251.262c-0.1-0.27-0.34-0.55-0.61-0.664c-0.289-0.122-0.63-0.166-0.928-0.04 c-0.303,0.128-0.494,0.329-0.664,0.61c-0.67,1.104-1.341,2.209-2.011,3.313c-0.151,0.249-0.137,0.667-0.04,0.928 c0.1,0.27,0.34,0.55,0.61,0.664c0.289,0.122,0.63,0.166,0.928,0.04c0.303-0.128,0.494-0.329,0.664-0.61 c0.67-1.104,1.341-2.209,2.011-3.313C219.832,251.941,219.818,251.523,219.72,251.262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M226.498,263.614c-2.068-0.445-4.135-0.889-6.203-1.334c-0.611-0.132-1.306,0.334-1.392,0.96 c-0.091,0.658,0.305,1.251,0.96,1.392c2.068,0.445,4.135,0.889,6.203,1.334c0.611,0.131,1.306-0.334,1.392-0.96 C227.548,264.348,227.152,263.755,226.498,263.614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M250.985,261.819c-0.186-0.24-0.45-0.442-0.76-0.485c-0.338-0.047-0.61,0.037-0.907,0.2 c-1.477,0.812-2.954,1.624-4.432,2.436c-0.245,0.135-0.437,0.497-0.485,0.76c-0.054,0.292,0.015,0.668,0.2,0.907 c0.186,0.24,0.45,0.442,0.76,0.485c0.339,0.047,0.61-0.037,0.907-0.2c1.477-0.812,2.954-1.624,4.432-2.436 c0.245-0.135,0.437-0.497,0.485-0.76C251.239,262.434,251.17,262.057,250.985,261.819z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M234.63,192.874c-1.255-1.847-2.509-3.694-3.764-5.54c-0.352-0.518-1.164-0.675-1.667-0.285 c-0.52,0.403-0.661,1.113-0.285,1.667c1.255,1.847,2.509,3.694,3.764,5.541c0.352,0.518,1.164,0.675,1.667,0.285 C234.865,194.138,235.006,193.428,234.63,192.874z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M247.843,189.087c-0.403-0.519-1.113-0.661-1.667-0.285c-1.626,1.106-3.252,2.213-4.877,3.319 c-0.517,0.352-0.675,1.163-0.285,1.667c0.403,0.519,1.113,0.661,1.667,0.285c1.626-1.106,3.252-2.213,4.877-3.319 C248.076,190.402,248.234,189.591,247.843,189.087z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0E4"
    },
    d: "M250.487,172.2c-2.694,0.295-11.764,1.1-16.506-0.837c-4.925-2.008-3.371-18.658-2.917-22.73 c2.503,2.216,5.738,3.897,9.803,3.897c5.26,0,8.847-3.037,11.23-6.456c-1.068,1.769-2.064,4.105-2.694,5.842 c-0.749,2.08-0.893,4.479,0.128,6.44c1.004,1.913,3.013,3.26,3.579,5.34c0.422,1.562-0.064,3.228-0.757,4.686 C251.754,169.665,250.989,170.877,250.487,172.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0E4"
    },
    d: "M256.178,136.566c-0.08,0.056-0.12,0.088-0.12,0.088l0.143,0.048 c-0.104,0.47-1.052,4.519-3.467,8.408c-0.008,0.016-0.016,0.024-0.024,0.04c-0.191,0.263-0.383,0.55-0.574,0.861 c-0.008,0.016-0.024,0.04-0.04,0.064c-2.383,3.419-5.969,6.456-11.23,6.456c-4.065,0-7.3-1.682-9.803-3.897 c-0.813-0.725-1.546-1.506-2.2-2.303c-3.331-4.009-4.782-8.496-4.782-8.496s-6.424-4.575-4.503-9.373 c1.921-4.806,5.683-1.777,5.683-1.777s0.757-9.269,8.703-11.373c7.954-2.104,10.576-7.46,10.648-10.999 c0,0,11.485,6.312,10.265,21.192c0,0,3.347-2.694,5.34,1.02c0.12,0.223,0.239,0.47,0.351,0.749 C262.322,131.689,257.054,135.905,256.178,136.566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0E4"
    },
    d: "M243.051,21.392c0.048,0.351,0.072,0.733,0.072,1.132c-0.008,2.981-1.172,7.045-1.172,7.045 c6.687,5.244,1.905,14.25,1.905,14.25s1.1,2.128,2.877,5.627c6.535,12.903,22.156,44.488,25.209,57.296 c3.873,16.291,1.371,72.893,1.371,72.893s-1.323-5.539-6.934-13.78c0.701-2.12,1.514-4.248,1.49-6.44 c-0.032-2.606-1.339-5.173-3.427-6.727c-1.307-0.98-2.861-1.554-4.272-2.375c-1.411-0.813-2.75-1.985-3.148-3.563 c-0.303-1.18-0.032-2.431,0.295-3.602c0.335-1.172,0.733-2.351,0.701-3.571c-0.032-1.219-0.622-2.511-1.737-2.997l-0.104-0.016 c0.877-0.662,6.145-4.878,4.391-9.293c-0.112-0.279-0.231-0.526-0.351-0.749c0.135-0.486,5.252-19.375-5.866-27.568 c-0.327-1.522-0.805-3.292-0.805-3.292l-11.437-28.724l-6.264-15.725l-1.881-4.734c0,0-3.419-14.035-2.646-17.064 c0.223-0.877,1.148-2.423,2.407-4.176c3.084-4.272,8.201-9.755,10.13-9.707C246.279,15.606,243.649,20.364,243.051,21.392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0E4"
    },
    d: "M235.846,51.216l6.264,15.725l-15.94,33.035c-10.56,9.181-6.591,28.485-6.591,28.485 c-1.921,4.798,4.503,9.373,4.503,9.373s1.451,4.487,4.782,8.496c-2.423,3.634-22.053,33.458-24.133,45.867 c0,0-5.962-12.999-4.136-37.26c0,0,2.662-37.06,5.985-47.198C209.673,98.302,232.714,56.843,235.846,51.216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48CCD"
    },
    d: "M260.44,126.061c-0.277-0.432-0.928,0.029-0.65,0.461c1.115,1.735,1.002,3.986,0.117,5.794 c-0.883,1.803-2.425,3.169-4.08,4.253c-0.429,0.281,0.031,0.932,0.461,0.65c1.851-1.212,3.569-2.791,4.473-4.85 C261.647,130.353,261.65,127.944,260.44,126.061z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48CCD"
    },
    d: "M224.627,137.219c-1.748-0.358-3.216-1.569-4.052-3.129c-0.996-1.857-1.036-4.065-0.53-6.071 c0.126-0.498-0.659-0.639-0.784-0.144c-0.561,2.225-0.449,4.655,0.673,6.693c0.95,1.726,2.609,3.038,4.55,3.435 C224.987,138.106,225.129,137.321,224.627,137.219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48CCD"
    },
    d: "M231.138,148.465c-0.386-0.34-0.897,0.271-0.512,0.611c2.432,2.143,5.563,3.465,8.799,3.695 c3.147,0.224,6.284-0.592,8.949-2.275c1.514-0.956,2.848-2.188,3.925-3.618c0.308-0.409-0.301-0.923-0.611-0.512 c-3.702,4.916-10.316,6.923-16.101,4.763"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0E4"
    },
    d: "M252.711,145.15c-0.183,0.287-0.375,0.574-0.574,0.861 C252.328,145.7,252.519,145.413,252.711,145.15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2849"
    },
    d: "M265.885,209.914h-46.68c0,0,5.101-8.121,21.662-8.121S265.885,209.914,265.885,209.914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2849"
    },
    d: "M254.352,98.956c11.118,8.193,6.001,27.082,5.866,27.568c-1.992-3.714-5.34-1.02-5.34-1.02 c1.219-14.88-10.265-21.192-10.265-21.192c-0.072,3.539-2.694,8.894-10.648,10.999c-7.946,2.104-8.703,11.373-8.703,11.373 s-3.762-3.029-5.683,1.777c0,0-3.969-19.303,6.591-28.485c3.3-2.869,8.01-4.75,14.697-4.75 C246.917,95.226,251.26,96.676,254.352,98.956z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F48CCD"
    },
    cx: 251.26,
    cy: 134,
    r: 3.618
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0E4"
    },
    d: "M247.785,29.793c5.834,6.79-1.052,19.654-1.052,19.654c-1.777-3.499-2.877-5.627-2.877-5.627 s4.782-9.006-1.905-14.25c0,0,1.164-4.065,1.172-7.045C246.59,23.433,247.785,29.793,247.785,29.793z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48CCD"
    },
    d: "M241.29,121.706l3.323,13.15l-2.144-0.08c0,0-3.355,2.885-4.352,1.706 C237.113,135.295,241.29,121.706,241.29,121.706z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F48CCD"
    },
    cx: 230.227,
    cy: 134,
    r: 3.618
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0E4"
    },
    d: "M233.726,25.242c-1.259,1.753-2.184,3.3-2.407,4.176C223.333,19.942,233.391,25.074,233.726,25.242 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48CCD"
    },
    d: "M246.759,48.924c-0.857-1.418-1.647-2.875-2.359-4.372c-0.155-0.327-0.374-0.688-0.413-1.054 c-0.044-0.416,0.217-0.799,0.395-1.154c0.352-0.701,0.662-1.424,0.914-2.167c0.889-2.628,1.035-5.547-0.274-8.064 c-0.598-1.149-1.463-2.105-2.55-2.799c0.367-1.635,0.743-3.268,1.099-4.905c0.315-1.449,0.542-2.992,0.012-4.421 c-0.362-0.974-1.468-2.572-2.527-1.389c-0.485,0.542-0.853,1.241-1.206,1.872c-0.401,0.717-0.766,1.455-1.132,2.19 c-0.887,1.778-1.773,3.556-2.66,5.334c-0.23,0.46,0.492,0.8,0.721,0.341c0.857-1.719,1.714-3.438,2.571-5.156 c0.383-0.768,0.761-1.539,1.177-2.289c0.218-0.392,0.445-0.78,0.691-1.155c0.201-0.306,0.488-0.945,0.904-0.614 c0.592,0.47,0.86,1.404,0.947,2.117c0.106,0.862-0.018,1.726-0.186,2.572c-0.365,1.833-0.812,3.653-1.221,5.476 c0,0.001,0,0.002,0,0.004c-0.08,0.179-0.052,0.417,0.166,0.54c2.289,1.296,3.398,3.96,3.375,6.507 c-0.015,1.582-0.433,3.148-1.047,4.598c-0.269,0.635-0.665,1.241-0.874,1.898c-0.22,0.692,0.034,1.287,0.33,1.912 c0.751,1.588,1.587,3.136,2.495,4.639C246.374,49.824,247.024,49.362,246.759,48.924z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48CCD"
    },
    d: "M242.129,66.52c-1.656-5.233-3.63-10.361-5.911-15.353c-0.212-0.463-0.961-0.19-0.747,0.278 c2.281,4.992,4.255,10.12,5.911,15.353C241.536,67.287,242.283,67.009,242.129,66.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48CCD"
    },
    d: "M233.289,25.237c-1.072,1.151-1.904,2.522-2.425,4.006c-0.071,0.203-0.019,0.432,0.19,0.531 c0.179,0.085,0.459,0.014,0.531-0.19c0.501-1.427,1.284-2.728,2.315-3.835C234.25,25.373,233.638,24.862,233.289,25.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2849"
    },
    d: "M264.211,186.713c-2.216,0.51-4.559-0.008-6.631-0.94c-2.471-1.116-4.702-2.869-6.121-5.188 c-1.411-2.311-1.953-5.212-1.164-7.811c0.056-0.191,0.128-0.383,0.191-0.574c0.502-1.323,1.267-2.534,1.865-3.818 c0.693-1.458,1.18-3.124,0.757-4.686c-0.566-2.08-2.574-3.427-3.579-5.34c-1.02-1.961-0.877-4.36-0.128-6.44 c0.63-1.737,1.626-4.073,2.694-5.842c0.016-0.024,0.032-0.048,0.04-0.064c0.199-0.287,0.391-0.574,0.574-0.861 c0.008-0.016,0.016-0.024,0.024-0.04c2.415-3.889,3.363-7.938,3.467-8.408l-0.143-0.048c0,0,0.04-0.032,0.12-0.088l0.104,0.016 c1.116,0.486,1.706,1.777,1.737,2.997c0.032,1.219-0.367,2.399-0.701,3.571c-0.327,1.172-0.598,2.423-0.295,3.602 c0.398,1.578,1.737,2.75,3.148,3.563c1.411,0.821,2.965,1.395,4.272,2.375c2.088,1.554,3.395,4.12,3.427,6.727 c0.024,2.192-0.789,4.32-1.49,6.44c-0.669,2.024-1.243,4.041-0.885,6.105c0.319,1.809,1.315,3.411,2.16,5.037 c0.837,1.634,1.546,3.459,1.211,5.26C268.443,184.497,266.427,186.203,264.211,186.713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2849"
    },
    d: "M229.687,261.721c-4.522-0.506-8.984-1.454-13.32-2.832c-0.488-0.155-0.627,0.631-0.144,0.784 c4.337,1.378,8.798,2.327,13.32,2.832C230.05,262.562,230.197,261.778,229.687,261.721z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2849"
    },
    d: "M239.563,261.927c-2.094,0.322-4.217,0.393-6.327,0.194c-0.508-0.048-0.655,0.736-0.144,0.784 c2.181,0.206,4.375,0.149,6.54-0.184C240.137,262.643,240.071,261.848,239.563,261.927z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2849"
    },
    d: "M234.678,258.966c-1.725,0.203-3.486,0.043-5.139-0.499c-0.206-0.068-0.428-0.021-0.531,0.19 c-0.085,0.175-0.014,0.464,0.19,0.531c1.79,0.587,3.675,0.792,5.549,0.572C235.256,259.7,235.188,258.906,234.678,258.966z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0E4"
    },
    d: "M265.072,464.785c11.517,18.219,5.428,19.383,5.428,19.383s-21.933,1.219-24.037,0 c-2.104-1.219,3.276-19.829,3.276-19.829l-9.747-30.908h20.762L265.072,464.785z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41E0E0"
    },
    d: "M260.752,293.184l-3.993,38.885l0.048,0.128l-1.156,0.43v41.874c0,0,0.55-0.032,1.498-0.606 l3.602,59.536h-20.762h-2.837l-5.316-62.811c-21.272-59.32-20.164-106.638-20.164-106.638s31.314,13.142,70.749-8.129 c0,0,50.442,44.313,59.089,59.599c8.639,15.286-51.853,28.254-51.853,28.254l-1.714-4.033h-0.008l-7.03-16.506H280.9 l-0.877-2.064l15.621-6.647L260.752,293.184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0E4"
    },
    d: "M257.15,373.895c-0.948,0.574-1.498,0.606-1.498,0.606v-41.874l1.156-0.43l24.093-9.03h0.008 l7.03,16.506l-16.219,3.475C265.997,366.045,259.9,372.23,257.15,373.895z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2849"
    },
    d: "M312.594,306.071c-4.211,1.546-8.423,3.092-12.634,4.637c-0.481,0.177-0.205,0.924,0.278,0.747 c4.212-1.546,8.423-3.092,12.634-4.637C313.353,306.641,313.077,305.893,312.594,306.071z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2849"
    },
    d: "M313.776,312.323c-3.921-0.052-7.842,0.073-11.752,0.376c-0.511,0.04-0.442,0.834,0.069,0.794 c3.91-0.302,7.831-0.427,11.752-0.376C314.358,313.124,314.285,312.33,313.776,312.323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2849"
    },
    d: "M275.928,278.808c-5.038,3.483-9.726,7.453-13.998,11.841c-0.358,0.368,0.254,0.878,0.611,0.512 c4.225-4.34,8.866-8.259,13.848-11.703C276.811,279.166,276.351,278.515,275.928,278.808z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2849"
    },
    d: "M254.502,424.926c-4.422,1.505-8.843,3.01-13.265,4.514c-0.485,0.165-0.208,0.913,0.278,0.747 c4.422-1.505,8.844-3.01,13.265-4.514C255.266,425.508,254.988,424.761,254.502,424.926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2849"
    },
    d: "M256.058,428.246c-3.168,0.718-6.389,1.183-9.629,1.407c-0.512,0.035-0.442,0.829,0.069,0.794 c3.314-0.229,6.599-0.72,9.838-1.454C256.834,428.881,256.552,428.134,256.058,428.246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2849"
    },
    d: "M296.238,335.124c-3.691-4.284-7.383-8.569-11.074-12.853c-0.332-0.385-0.986,0.071-0.651,0.461 c3.691,4.284,7.383,8.569,11.074,12.853C295.919,335.97,296.573,335.514,296.238,335.124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2849"
    },
    d: "M291.67,335.11c-1.604-1.645-3.209-3.289-4.813-4.934c-0.15-0.154-0.433-0.104-0.561,0.049 c-0.15,0.179-0.102,0.407,0.049,0.561c1.604,1.645,3.209,3.289,4.813,4.934c0.15,0.154,0.433,0.104,0.561-0.049 C291.869,335.493,291.821,335.265,291.67,335.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M237.717,399.179c-0.323-5.667-0.513-11.342-0.503-17.018c0.01-5.58,0.36-11.217-0.608-16.744 c-0.924-5.27-2.874-10.274-4.64-15.302c-1.798-5.12-3.444-10.293-4.935-15.51c-3.002-10.502-5.375-21.182-7.108-31.967 c-1.721-10.715-2.811-21.532-3.255-32.375c-0.056-1.369-0.101-2.738-0.137-4.107c-0.014-0.513-0.808-0.442-0.794,0.069 c0.288,10.85,1.209,21.68,2.771,32.42c1.551,10.67,3.728,21.251,6.512,31.668c1.401,5.242,2.957,10.443,4.667,15.593 c1.704,5.134,3.753,10.174,5.177,15.396c1.496,5.484,1.672,11.011,1.598,16.662c-0.074,5.667-0.007,11.329,0.244,16.991 c0.503,11.351,1.607,22.665,2.777,33.963c0.148,1.426,0.296,2.852,0.445,4.278c0.053,0.51,0.847,0.442,0.794-0.069 C239.543,421.828,238.364,410.523,237.717,399.179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48CCD"
    },
    d: "M264.207,479.742c-0.056-0.509-0.851-0.441-0.794,0.069c0.139,1.251,0.217,2.507,0.233,3.766 c0.003,0.215,0.229,0.38,0.432,0.362c0.228-0.02,0.365-0.216,0.362-0.432C264.424,482.249,264.346,480.993,264.207,479.742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48CCD"
    },
    d: "M259.321,479.742c-0.018-0.513-0.812-0.442-0.794,0.069c0.048,1.354,0.095,2.708,0.143,4.062 c0.018,0.513,0.812,0.442,0.794-0.069C259.416,482.45,259.368,481.096,259.321,479.742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48CCD"
    },
    d: "M254.556,480.036c-0.017-0.513-0.811-0.442-0.794,0.069c0.042,1.28,0.084,2.561,0.126,3.841 c0.017,0.513,0.811,0.442,0.794-0.069C254.64,482.597,254.598,481.316,254.556,480.036z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48CCD"
    },
    d: "M249.842,480.626c-0.013-0.215-0.221-0.381-0.432-0.362c-0.22,0.019-0.375,0.216-0.362,0.432 c0.056,0.939,0.126,1.877,0.209,2.813c0.045,0.511,0.839,0.442,0.794-0.069C249.967,482.502,249.898,481.564,249.842,480.626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48CCD"
    },
    d: "M259.47,367.149c-0.202-0.096-0.43-0.001-0.531,0.19c-0.334,0.631-0.67,1.269-1.151,1.803 c-0.21,0.233-0.427,0.421-0.698,0.594c-0.233,0.148-0.548,0.278-0.804,0.323c-0.212,0.037-0.382,0.204-0.362,0.432 c0.018,0.2,0.219,0.4,0.432,0.362c0.778-0.137,1.443-0.559,1.98-1.129c0.559-0.594,0.947-1.329,1.325-2.044 C259.76,367.489,259.658,367.238,259.47,367.149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48CCD"
    },
    d: "M258.271,363.507c-0.188-0.079-0.449-0.017-0.531,0.19c-0.049,0.123-0.103,0.244-0.166,0.361 c-0.03,0.056-0.062,0.111-0.094,0.165c-0.008,0.013-0.007,0.012-0.01,0.017c-0.003,0.005-0.003,0.003-0.01,0.014 c-0.019,0.029-0.039,0.057-0.059,0.085c-0.073,0.103-0.153,0.203-0.237,0.298c-0.046,0.052-0.093,0.102-0.142,0.151 c-0.02,0.02-0.042,0.04-0.062,0.06c-0.02,0.019-0.017,0.016,0.012-0.01c-0.013,0.012-0.026,0.023-0.039,0.035 c-0.195,0.172-0.408,0.32-0.635,0.447c-0.01,0.006-0.01,0.006-0.013,0.008c-0.005,0.002-0.005,0.002-0.018,0.008 c-0.026,0.012-0.052,0.025-0.078,0.038c-0.057,0.027-0.115,0.052-0.174,0.076c-0.129,0.052-0.26,0.094-0.394,0.13 c-0.202,0.054-0.313,0.327-0.235,0.513c0.091,0.214,0.296,0.292,0.513,0.235c1.144-0.305,2.127-1.189,2.561-2.289 C258.537,363.844,258.478,363.595,258.271,363.507z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M241.861,104.828c-0.447,1.829-1.52,3.48-3.008,4.633c-0.404,0.313,0.054,0.966,0.461,0.651 c1.657-1.285,2.834-3.103,3.331-5.14C242.767,104.472,241.983,104.331,241.861,104.828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M236.64,111.532c-1.041,0.75-2.215,1.275-3.465,1.562c-0.21,0.048-0.302,0.33-0.235,0.513 c0.083,0.223,0.302,0.283,0.513,0.235c1.312-0.302,2.556-0.872,3.648-1.659C237.517,111.883,237.058,111.231,236.64,111.532z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M237.284,108.76c-0.115-0.162-0.393-0.237-0.556-0.095c-1.054,0.922-2.284,1.597-3.629,1.986 c-0.207,0.06-0.305,0.322-0.235,0.513c0.08,0.214,0.305,0.295,0.513,0.235c1.402-0.406,2.713-1.122,3.811-2.083 C237.351,109.175,237.418,108.949,237.284,108.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M255.488,162.232c-0.215-0.461-0.964-0.188-0.747,0.278c0.925,1.984,0.15,4.181-0.767,6.017 c-0.896,1.794-1.965,3.552-2.185,5.586c-0.055,0.508,0.729,0.654,0.784,0.144C253.011,170.205,257.478,166.503,255.488,162.232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M254.708,179.902c-1.086-0.822-1.841-2.046-2.053-3.395c-0.033-0.213-0.207-0.382-0.432-0.362 c-0.203,0.018-0.396,0.218-0.362,0.432c0.244,1.553,1.078,2.984,2.335,3.936C254.604,180.821,255.118,180.212,254.708,179.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M255.596,177.1c-0.773-0.834-1.171-2.028-1.067-3.158c0.02-0.214-0.095-0.423-0.32-0.464 c-0.197-0.036-0.444,0.105-0.464,0.32c-0.132,1.445,0.355,2.85,1.339,3.913c0.146,0.158,0.435,0.101,0.561-0.049 C255.798,177.479,255.743,177.258,255.596,177.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M265.162,157.334c-0.119-0.179-0.384-0.217-0.556-0.095c-0.18,0.128-0.215,0.376-0.095,0.556 c0.506,0.759,0.647,1.688,0.412,2.576c-0.055,0.208,0.12,0.427,0.32,0.464c0.226,0.041,0.409-0.111,0.464-0.32 C265.993,159.436,265.779,158.259,265.162,157.334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M265.02,162.636c-0.228-0.031-0.407,0.104-0.464,0.32c-0.216,0.814-0.431,1.628-0.647,2.442 c-0.053,0.202,0.118,0.436,0.32,0.464c0.228,0.031,0.407-0.104,0.464-0.32c0.216-0.814,0.431-1.628,0.647-2.442 C265.393,162.898,265.222,162.663,265.02,162.636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48CCD"
    },
    d: "M228.192,143.945c-1.426-1.948-2.506-4.114-3.205-6.425c-0.149-0.491-0.896-0.212-0.747,0.278 c0.718,2.37,1.839,4.609,3.302,6.607C227.844,144.819,228.496,144.36,228.192,143.945z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48CCD"
    },
    d: "M255.734,136.646c-0.526,2.171-1.356,4.252-2.458,6.195c-0.254,0.447,0.469,0.785,0.721,0.341 c1.136-2.002,1.98-4.155,2.522-6.392C256.639,136.29,255.854,136.149,255.734,136.646z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2849"
    },
    d: "M236.649,120.639c-0.046-0.673-0.553-1.15-1.224-1.167c-2.45-0.062-4.932,0.684-6.938,2.094 c-0.511,0.359-0.768,1.089-0.39,1.645c0.346,0.51,1.098,0.774,1.645,0.39c0.453-0.318,0.927-0.603,1.424-0.847 c0.057-0.028,0.114-0.055,0.172-0.082c0.006-0.003,0.009-0.004,0.016-0.007c0.128-0.053,0.255-0.107,0.384-0.156 c0.242-0.093,0.487-0.177,0.735-0.252c0.248-0.075,0.499-0.141,0.752-0.198c0.135-0.03,0.271-0.055,0.406-0.082 c0.035-0.006,0.061-0.011,0.078-0.014c0.039-0.006,0.078-0.011,0.117-0.017c0.549-0.072,1.101-0.098,1.654-0.084 C236.108,121.879,236.692,121.262,236.649,120.639z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2849"
    },
    d: "M236.653,124.544c-0.754,1.105-1.928,1.908-3.261,2.114c-1.373,0.212-2.777-0.192-3.846-1.074 c-0.396-0.327-0.909,0.284-0.512,0.611c1.221,1.007,2.854,1.5,4.427,1.257c1.533-0.236,2.928-1.114,3.802-2.395 C237.55,124.636,236.942,124.12,236.653,124.544z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2849"
    },
    d: "M245.926,120.639c0.046-0.673,0.553-1.15,1.224-1.167c2.45-0.062,4.932,0.684,6.938,2.094 c0.511,0.359,0.768,1.089,0.39,1.645c-0.346,0.51-1.098,0.774-1.645,0.39c-0.453-0.318-0.927-0.603-1.424-0.847 c-0.057-0.028-0.114-0.055-0.172-0.082c-0.006-0.003-0.009-0.004-0.016-0.007c-0.128-0.053-0.255-0.107-0.384-0.156 c-0.242-0.093-0.487-0.177-0.735-0.252c-0.248-0.075-0.499-0.141-0.752-0.198c-0.135-0.03-0.271-0.055-0.406-0.082 c-0.035-0.006-0.061-0.011-0.078-0.014c-0.039-0.006-0.078-0.011-0.117-0.017c-0.549-0.072-1.101-0.098-1.654-0.084 C246.467,121.879,245.883,121.262,245.926,120.639z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2849"
    },
    d: "M245.922,124.544c0.754,1.105,1.928,1.908,3.261,2.114c1.373,0.212,2.777-0.192,3.846-1.074 c0.396-0.327,0.909,0.284,0.512,0.611c-1.221,1.007-2.854,1.5-4.427,1.257c-1.533-0.236-2.928-1.114-3.802-2.395 C245.025,124.636,245.633,124.12,245.922,124.544z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2849"
    },
    d: "M245.849,139.808c-1.05,1.496-2.813,2.459-4.643,2.508c-1.885,0.051-3.733-0.873-4.857-2.38 c-0.304-0.408-0.985,0.007-0.678,0.42c1.294,1.735,3.374,2.816,5.555,2.758c2.132-0.057,4.106-1.188,5.321-2.92 C246.842,139.772,246.141,139.392,245.849,139.808z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#518AFC"
    },
    cx: 334.196,
    cy: 134.617,
    r: 25.761
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2849"
    },
    d: "M343.416,130.673l-12.802,12.802c-1.288,1.288-3.394,1.288-4.682,0l-0.936-0.936 c-1.288-1.288-1.288-3.394,0-4.682l12.802-12.802c1.288-1.288,3.394-1.288,4.682,0l0.936,0.936 C344.703,127.279,344.703,129.386,343.416,130.673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M335.793,149.258l-2.853,2.853c-1.172,1.172-3.09,1.172-4.262,0l-11.788-11.788 c-1.172-1.172-1.172-3.09,0-4.262l2.853-2.853c1.172-1.172,3.09-1.172,4.262,0l11.788,11.788 C336.965,146.168,336.965,148.086,335.793,149.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M351.887,131.609l-2.853,2.853c-1.172,1.172-3.09,1.172-4.262,0l-11.788-11.788 c-1.172-1.172-1.172-3.09,0-4.262l2.853-2.853c1.172-1.172,3.09-1.172,4.262,0l11.788,11.788 C353.059,128.519,353.059,130.437,351.887,131.609z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.173,
    y: 142.951,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -9.7116 270.4009)",
    style: {
      fill: "#2C2849"
    },
    width: 2.747,
    height: 7.946
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.934,
    y: 147.321,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -11.6565 269.4244)",
    style: {
      fill: "#9792E0"
    },
    width: 2.925,
    height: 2.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.591,
    y: 116.509,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 677.4987 -39.6656)",
    style: {
      fill: "#2C2849"
    },
    width: 2.747,
    height: 7.946
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.653,
    y: 117.16,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 679.8562 -44.361)",
    style: {
      fill: "#9792E0"
    },
    width: 2.925,
    height: 2.925
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2849"
    },
    d: "M317.898,137.243l13.348,13.348c0.435,0.435,1.047-0.3,0.615-0.733l-13.348-13.348 C318.077,136.075,317.465,136.81,317.898,137.243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2849"
    },
    d: "M337.233,116.924l13.348,13.348c0.435,0.435,1.047-0.3,0.615-0.733l-13.348-13.348 C337.413,115.757,336.8,116.492,337.233,116.924z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 369.9461 130.0921)",
    style: {
      fill: "#2C2849",
      fontFamily: "'TrashHand'",
      fontSize: "21.0825px"
    }
  }, "Stay")), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 367.2604 149.1407)",
    style: {
      fill: "#2C2849",
      fontFamily: "'TrashHand'",
      fontSize: "21.0825px"
    }
  }, "Active")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#41E0E0"
    },
    cx: 351.906,
    cy: 203.441,
    r: 25.761
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0E4"
    },
    d: "M373.933,207.196c0,11.213-9.09,13.578-20.302,13.578s-20.302-2.365-20.302-13.578 c0-11.212,9.09-20.302,20.302-20.302S373.933,195.983,373.933,207.196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2849"
    },
    d: "M349.791,199.179c-0.885,1.523-2.565,2.517-4.327,2.555c-1.773,0.038-3.458-0.945-4.403-2.421 c-0.344-0.536-1.151,0.036-0.808,0.572c1.14,1.779,3.182,2.878,5.297,2.835c2.124-0.044,4.081-1.303,5.136-3.118 C351.006,199.05,350.109,198.632,349.791,199.179z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#88D159"
    },
    cx: 340.314,
    cy: 209.183,
    r: 3.897
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2849"
    },
    d: "M358.105,198.872c0.885,1.523,2.565,2.517,4.327,2.555c1.773,0.038,3.458-0.945,4.403-2.421 c0.344-0.536,1.151,0.036,0.808,0.572c-1.14,1.779-3.182,2.878-5.297,2.835c-2.124-0.044-4.081-1.303-5.136-3.118 C356.89,198.744,357.787,198.326,358.105,198.872z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#88D159"
    },
    cx: 367.582,
    cy: 208.876,
    r: 3.897
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#2C2849"
    },
    cx: 353.825,
    cy: 209.183,
    rx: 2.739,
    ry: 3.013
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2849"
    },
    d: "M331.072,176.726c-6.245,0-11.324,4.878-11.324,10.884c0,6.006,5.078,10.884,11.324,10.884 c6.245,0,11.324-4.878,11.324-10.884C342.396,181.604,337.317,176.726,331.072,176.726z M331.072,196.581 c-5.184,0-9.411-4.026-9.411-8.971c0-4.945,4.227-8.971,9.411-8.971c5.193,0,9.411,4.026,9.411,8.971 C340.483,192.554,336.265,196.581,331.072,196.581z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 331.072,
    cy: 187.61,
    rx: 9.411,
    ry: 8.971
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2849"
    },
    d: "M331.072,188.566c-0.186,0-0.371-0.054-0.531-0.161c-0.266-0.177-0.426-0.476-0.426-0.796 v-7.173c0-0.528,0.428-0.956,0.956-0.956s0.956,0.428,0.956,0.956v5.738l3.552-1.481c0.488-0.203,1.047,0.027,1.251,0.515 c0.204,0.488-0.027,1.047-0.515,1.251l-4.876,2.033C331.322,188.542,331.197,188.566,331.072,188.566z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2849"
    },
    d: "M368.985,186.181h-8.848c-0.294,0-0.559-0.177-0.671-0.448c-0.113-0.272-0.05-0.584,0.157-0.791 l7.609-7.609h-4.561c-0.401,0-0.726-0.325-0.726-0.726c0-0.401,0.325-0.726,0.726-0.726h6.314c0.294,0,0.559,0.177,0.671,0.448 c0.113,0.272,0.05,0.584-0.157,0.791l-7.609,7.609h7.095c0.401,0,0.726,0.325,0.726,0.726 C369.712,185.856,369.387,186.181,368.985,186.181z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2849"
    },
    d: "M377.294,192.044h-7.784c-0.258,0-0.492-0.156-0.59-0.394c-0.099-0.239-0.044-0.513,0.138-0.696 l6.693-6.693h-4.012c-0.353,0-0.639-0.286-0.639-0.639c0-0.353,0.286-0.639,0.639-0.639h5.555c0.258,0,0.492,0.156,0.59,0.394 c0.099,0.239,0.044,0.513-0.138,0.696l-6.693,6.693h6.241c0.353,0,0.639,0.286,0.639,0.639 C377.933,191.758,377.647,192.044,377.294,192.044z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 385.5477 195.9613)",
    style: {
      fill: "#2C2849",
      fontFamily: "'TrashHand'",
      fontSize: "21.0825px"
    }
  }, "Get Enough")))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 388.3065 216.3773)",
    style: {
      fill: "#2C2849",
      fontFamily: "'TrashHand'",
      fontSize: "21.0825px"
    }
  }, "Sleep"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#518AFC"
    },
    cx: 131.185,
    cy: 202.541,
    r: 25.761
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80FFFF"
    },
    d: "M130.767,224.756c-18.365,0,0-26.305,0-26.305S149.125,224.756,130.767,224.756z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M129.348,221.168c-0.04,0-0.08,0-0.12,0c0.072,0.001,0.07-0.001-0.006-0.007 c-0.078-0.01-0.156-0.021-0.233-0.035c-0.218-0.041-0.234-0.046-0.353-0.093c-0.365-0.143-0.52-0.232-0.788-0.446 c-0.526-0.419-0.897-0.932-1.131-1.534c-0.608-1.569-0.183-3.344,0.444-4.836c0.226-0.539,0.029-1.185-0.517-1.443 c-0.512-0.242-1.216-0.025-1.443,0.517c-0.874,2.083-1.387,4.593-0.422,6.743c0.858,1.913,2.62,3.289,4.758,3.294 c0.586,0.001,1.033-0.628,0.985-1.174C130.467,221.526,129.935,221.169,129.348,221.168z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80FFFF"
    },
    d: "M116.904,207.716c-15.489,0,0-22.186,0-22.186S132.387,207.716,116.904,207.716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M115.706,204.69c-0.034,0-0.067,0-0.101,0c0.061,0.001,0.059-0.001-0.005-0.006 c-0.066-0.009-0.131-0.017-0.197-0.03c-0.184-0.035-0.197-0.039-0.298-0.078c-0.308-0.12-0.438-0.196-0.664-0.376 c-0.444-0.354-0.757-0.786-0.953-1.294c-0.513-1.323-0.154-2.82,0.374-4.079c0.191-0.455,0.024-1-0.436-1.217 c-0.432-0.204-1.025-0.021-1.217,0.436c-0.737,1.757-1.17,3.874-0.356,5.687c0.724,1.614,2.21,2.774,4.013,2.779 c0.494,0.001,0.871-0.53,0.831-0.99C116.65,204.991,116.202,204.691,115.706,204.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80FFFF"
    },
    d: "M144.214,208.246c-15.489,0,0-22.186,0-22.186S159.697,208.246,144.214,208.246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M143.017,205.22c-0.034,0-0.068,0-0.101,0c0.061,0.001,0.059-0.001-0.005-0.006 c-0.066-0.009-0.131-0.017-0.197-0.03c-0.184-0.035-0.197-0.039-0.298-0.078c-0.308-0.12-0.438-0.196-0.664-0.376 c-0.444-0.354-0.757-0.786-0.954-1.294c-0.513-1.323-0.154-2.82,0.374-4.079c0.191-0.455,0.024-1-0.436-1.217 c-0.432-0.204-1.025-0.021-1.217,0.436c-0.737,1.757-1.17,3.874-0.356,5.687c0.724,1.614,2.21,2.774,4.013,2.779 c0.494,0.001,0.871-0.53,0.831-0.99C143.961,205.522,143.512,205.221,143.017,205.22z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 68.0436 194.8071)",
    style: {
      fill: "#2C2849",
      fontFamily: "'TrashHand'",
      fontSize: "21.0825px"
    }
  }, "Stay")))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 35.5025 214.1164)",
    style: {
      fill: "#2C2849",
      fontFamily: "'TrashHand'",
      fontSize: "21.0825px"
    }
  }, "Hydrated"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#518AFC"
    },
    cx: 347.265,
    cy: 269.701,
    r: 25.761
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M367.38,263.42l2.293,4.409c1.056,2.03,0.259,4.555-1.771,5.611l0,0 c-2.03,1.056-4.555,0.259-5.611-1.771l-2.293-4.409L367.38,263.42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M359.998,267.26l-2.293-4.409c-1.056-2.03-0.259-4.555,1.771-5.611l0,0 c2.03-1.056,4.555-0.259,5.611,1.771l2.293,4.409L359.998,267.26z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M373.531,283.086l-4.287,2.514c-1.974,1.158-4.536,0.49-5.694-1.484l0,0 c-1.158-1.974-0.49-4.536,1.484-5.694l4.287-2.514L373.531,283.086z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M369.322,275.908l4.287-2.514c1.974-1.158,4.536-0.49,5.694,1.484l0,0 c1.158,1.974,0.49,4.536-1.484,5.694l-4.287,2.514L369.322,275.908z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#88D159"
    },
    cx: 372.657,
    cy: 259.839,
    r: 2.743
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#88D159"
    },
    cx: 378.834,
    cy: 263.923,
    r: 1.759
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 373.368,
    cy: 265.835,
    r: 1.71
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 341.607,
    y: 248.78,
    style: {
      fill: "#41E0E0"
    },
    width: 6.997,
    height: 6.616
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "339.781,256.812 339.781,255.397 342.079,255.397 348.077,255.397 350.429,255.397  350.429,256.812 346.706,256.812 343.536,256.812  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.902,
    y: 248.78,
    style: {
      fill: "#80FFFF"
    },
    width: 3.705,
    height: 6.616
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.603,
    y: 248.78,
    style: {
      fill: "#80FFFF"
    },
    width: 3.705,
    height: 6.616
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M355.491,262.877v26.75c0,0.813-0.65,1.463-1.463,1.463h-18.162c-0.803,0-1.463-0.65-1.463-1.463 v-26.75c0-2.888,1.894-5.327,4.505-6.14c0.612-0.191,1.253-0.296,1.932-0.296h8.215c0.765,0,1.492,0.124,2.171,0.373 C353.712,257.703,355.491,260.075,355.491,262.877z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#88D159"
    },
    points: "351.013,272.881 351.013,276.519 346.77,276.519 346.77,280.762 343.132,280.762  343.132,276.519 338.888,276.519 338.888,272.881 343.132,272.881 343.132,268.637 346.77,268.637 346.77,272.881  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41E0E0"
    },
    d: "M335.865,291.09c0,0,7.877-7.388,18.162,0H335.865z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41E0E0"
    },
    d: "M339.754,257.9h10.675c0,0-2.301,2.26-5.857,2.26C341.015,260.16,339.754,257.9,339.754,257.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 386.6467 266.5424)",
    style: {
      fill: "#2C2849",
      fontFamily: "'TrashHand'",
      fontSize: "21.0825px"
    }
  }, "Supplement")))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 386.6468 285.6433)",
    style: {
      fill: "#2C2849",
      fontFamily: "'TrashHand'",
      fontSize: "21.0825px"
    }
  }, "Wisely"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#41E0E0"
    },
    cx: 156.648,
    cy: 134.617,
    r: 25.761
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0E4"
    },
    d: "M177.465,137.432c0,11.213-9.09,13.578-20.302,13.578c-11.213,0-20.302-2.365-20.302-13.578 s9.09-20.302,20.302-20.302C168.375,117.13,177.465,126.22,177.465,137.432z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#88D159"
    },
    cx: 143.846,
    cy: 139.419,
    r: 3.897
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#88D159"
    },
    cx: 171.115,
    cy: 139.113,
    r: 3.897
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 149.828,
    cy: 129.185,
    rx: 2.664,
    ry: 3.91
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 164.553,
    cy: 129.185,
    rx: 2.664,
    ry: 3.91
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2849"
    },
    d: "M150.62,137.109h13.176c0,0-0.666,5.182-6.633,5.182 C151.196,142.29,150.62,137.109,150.62,137.109z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 93.8835 130.274)",
    style: {
      fill: "#3B4148",
      fontFamily: "'TrashHand'",
      fontSize: "21.0825px"
    }
  }, "Stay")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 69.8083 149.1251)",
    style: {
      fill: "#2C2849",
      fontFamily: "'TrashHand'",
      fontSize: "21.0825px"
    }
  }, "positive")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#41E0E0"
    },
    cx: 137.961,
    cy: 269.701,
    r: 25.761
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D159"
    },
    d: "M145.249,267.343l-0.262-0.262c-0.156-0.32-0.352-0.631-0.573-0.934 c-1.696-2.286-3.63-4.056-5.416-5.366c-0.197-0.147-0.401-0.287-0.614-0.401c0.188-0.827,2.614-10.741,5.989-11.151 c3.515-0.434,0.836,6.817,0.836,6.817s4.785-6.194,7.865-3.425l-0.016,0.016c2.761,3.072-3.433,7.873-3.433,7.873 s7.243-2.687,6.817,0.836C156.007,264.86,145.249,267.343,145.249,267.343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0E4"
    },
    d: "M142.668,275.593c-6.825,4.432-18.5,11.29-21.49,8.3c-2.974-2.974,3.834-14.616,8.267-21.441 c1.958-3.007,5.924-3.859,8.939-2.073c0.213,0.115,0.418,0.254,0.614,0.401c1.786,1.311,3.72,3.081,5.416,5.366 c0.221,0.303,0.418,0.614,0.573,0.934C146.494,270.014,145.536,273.725,142.668,275.593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48CCD"
    },
    d: "M144.09,273.392c-2.76-5.328-7.281-9.625-12.724-12.146c-0.676-0.313-1.161,0.74-0.482,1.054 c5.271,2.442,9.581,6.594,12.252,11.75C143.479,274.711,144.429,274.045,144.09,273.392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48CCD"
    },
    d: "M139.334,277.363c-2.793-4.831-6.977-8.747-11.964-11.246c-0.666-0.334-1.149,0.72-0.482,1.054 c4.811,2.411,8.8,6.193,11.492,10.85C138.754,278.668,139.705,278.005,139.334,277.363z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48CCD"
    },
    d: "M134.374,280.339c-2.557-3.638-6.016-6.558-10.031-8.47c-0.673-0.32-1.157,0.733-0.482,1.054 c3.83,1.824,7.119,4.603,9.559,8.074C133.849,281.607,134.803,280.949,134.374,280.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48CCD"
    },
    d: "M128.446,283.381c-1.849-2.323-4.07-4.282-6.595-5.84c-0.268-0.166-0.647,0.028-0.768,0.286 c-0.147,0.312,0.021,0.604,0.286,0.768c2.337,1.442,4.414,3.297,6.123,5.444C127.954,284.62,128.91,283.965,128.446,283.381z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 66.8963 262.9915)",
    style: {
      fill: "#2C2849",
      fontFamily: "'TrashHand'",
      fontSize: "21.0825px"
    }
  }, "Watch")))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 41.9185 282.627)",
    style: {
      fill: "#2C2849",
      fontFamily: "'TrashHand'",
      fontSize: "21.0825px"
    }
  }, "Your Diet"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 98.0865 332.1978)",
    style: {
      fill: "#3B4148",
      fontFamily: "'TrashHand'",
      fontSize: "21.0825px"
    }
  }, "Hygiene")))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 110.0679 352.2495)",
    style: {
      fill: "#2C2849",
      fontFamily: "'TrashHand'",
      fontSize: "21.0825px"
    }
  }, "Habits")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#518AFC"
    },
    cx: 183.712,
    cy: 334.389,
    r: 25.761
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0E4"
    },
    d: "M188.498,317.354l4.82,4.82c2.435,2.435,2.441,6.414,0.006,8.849l-13.422,13.422 c-2.435,2.435-6.42,2.435-8.855,0l-4.82-4.82c-2.435-2.435-2.429-6.414,0.006-8.849l13.422-13.422 C182.09,314.919,186.062,314.919,188.498,317.354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48CCD"
    },
    d: "M170.895,339.84c-1.265-1.265-1.898-2.935-1.891-4.598c0-1.67,0.633-3.34,1.891-4.598 l8.039-8.039c2.524-2.524,6.667-2.53,9.197,0c1.265,1.265,1.897,2.935,1.891,4.598c0,1.67-0.626,3.333-1.891,4.598 l-8.039,8.039C177.568,342.363,173.425,342.37,170.895,339.84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48CCD"
    },
    d: "M193.317,322.174l3.213,3.213c2.435,2.435,2.441,6.414,0.006,8.849l-13.422,13.422 c-2.435,2.435-6.42,2.435-8.855,0l-3.213-3.213c2.435,2.435,6.42,2.435,8.855,0l13.422-13.422 C195.759,328.587,195.752,324.609,193.317,322.174z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 199.06,
    cy: 326.683,
    r: 5.974
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 193.506,
    cy: 316.162,
    r: 2.273
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 169.689,
    cy: 320.471,
    r: 3.382
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M202.662,348.35c0,0.83-0.29,1.6-0.76,2.21h-33.19c-0.06-0.25-0.09-0.52-0.09-0.79 c0-1.99,1.62-3.61,3.61-3.61c0.34,0,0.67,0.05,0.99,0.14c-0.01-0.04-0.01-0.09-0.01-0.14c0-2.34,1.9-4.24,4.24-4.24 c0.48,0,0.94,0.08,1.37,0.23c-0.01-0.08-0.01-0.15-0.01-0.23c0-3.86,3.14-6.99,7-6.99c3.46,0,6.35,2.52,6.9,5.83 c0.45-0.14,0.92-0.21,1.41-0.21c2.47,0,4.52,1.81,4.87,4.19h0.06C201.042,344.74,202.662,346.36,202.662,348.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41E0E0"
    },
    d: "M184.896,335.736c-1.388,0.206-2.68,0.902-3.579,1.987c-0.933,1.127-1.379,2.607-1.268,4.061 c0.049,0.642,1.045,0.555,0.996-0.087c-0.184-2.41,1.539-4.608,3.938-4.965C185.617,336.638,185.534,335.641,184.896,335.736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41E0E0"
    },
    d: "M177.38,342.707c-0.744,0.147-1.403,0.52-1.91,1.088c-0.471,0.528-0.793,1.221-0.843,1.93 c-0.019,0.26,0.114,0.543,0.401,0.582c0.244,0.034,0.562-0.122,0.582-0.401c0.011-0.148,0.032-0.294,0.066-0.438 c0.009-0.036,0.018-0.072,0.028-0.107c0.002-0.008,0.004-0.015,0.007-0.023c0.011-0.016,0.068-0.181,0.077-0.201 c0.029-0.068,0.061-0.135,0.095-0.2c0.019-0.035,0.074-0.182,0.11-0.192c-0.033,0.05-0.039,0.06-0.019,0.03 c0.01-0.015,0.021-0.031,0.031-0.046c0.021-0.03,0.043-0.06,0.065-0.09c0.045-0.059,0.091-0.117,0.14-0.173 c0.049-0.056,0.099-0.11,0.152-0.162c0.004-0.004,0.01-0.011,0.017-0.018c-0.002,0.002-0.001,0.001-0.003,0.003 c0.023-0.027,0.057-0.05,0.084-0.073c0.114-0.095,0.234-0.181,0.361-0.257c0.026-0.016,0.056-0.037,0.085-0.049 c0.009-0.005,0.018-0.009,0.027-0.014c0.061-0.03,0.123-0.057,0.186-0.082c0.069-0.027,0.138-0.052,0.209-0.073 c0.035-0.011,0.071-0.021,0.107-0.03c0.013-0.003,0.011-0.003,0.018-0.005c0.005-0.001,0.002,0,0.014-0.002 c0.256-0.051,0.493-0.254,0.455-0.542C177.889,342.917,177.654,342.653,177.38,342.707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41E0E0"
    },
    d: "M172.901,348.095c0.079-0.094,0.131-0.241,0.115-0.365c-0.017-0.128-0.071-0.258-0.177-0.339 c-0.097-0.075-0.239-0.143-0.365-0.115c-0.466,0.105-0.904,0.285-1.285,0.579c-0.376,0.29-0.682,0.654-0.9,1.075 c-0.121,0.233-0.004,0.564,0.238,0.666c0.257,0.108,0.537,0.01,0.666-0.238c0.02-0.039,0.042-0.078,0.064-0.117 c0.005-0.009,0.016-0.026,0.026-0.043c0.051-0.076,0.107-0.149,0.166-0.219c0.057-0.067,0.117-0.132,0.18-0.193 c0.009-0.008,0.02-0.018,0.025-0.022c0.037-0.032,0.075-0.063,0.114-0.093c0.07-0.054,0.143-0.105,0.219-0.152 c0.037-0.023,0.074-0.045,0.112-0.066c0.014-0.007,0.028-0.014,0.041-0.02c0.169-0.08,0.345-0.141,0.527-0.184 c-0.044,0.01-0.087,0.02-0.131,0.029l0.026-0.006C172.697,348.242,172.807,348.207,172.901,348.095z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41E0E0"
    },
    d: "M197.958,343.382c-1.14-1.357-2.969-2.074-4.728-1.764c-0.266,0.047-0.48,0.256-0.455,0.542 c0.022,0.251,0.274,0.502,0.542,0.455c1.391-0.246,2.897,0.242,3.825,1.346c0.173,0.206,0.464,0.284,0.697,0.119 C198.045,343.933,198.132,343.59,197.958,343.382z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41E0E0"
    },
    d: "M198.847,322.981c-0.103-0.278-0.38-0.358-0.643-0.294c-1.24,0.299-2.326,1.196-2.862,2.353 c-0.604,1.3-0.476,2.826,0.246,4.048c0.137,0.232,0.49,0.266,0.697,0.119c0.235-0.167,0.257-0.464,0.119-0.697 c-0.553-0.936-0.603-2.142-0.122-3.117c0.447-0.907,1.298-1.533,2.271-1.768C198.815,323.561,198.933,323.213,198.847,322.981z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41E0E0"
    },
    d: "M199.517,330.607c-0.084-0.108-0.186-0.165-0.318-0.203c-0.432-0.124-0.865-0.247-1.297-0.371 c-0.118-0.034-0.283,0.016-0.379,0.084c-0.098,0.07-0.186,0.197-0.203,0.318c-0.018,0.13,0.001,0.273,0.084,0.379 c0.084,0.108,0.186,0.165,0.318,0.203c0.432,0.124,0.865,0.247,1.297,0.371c0.118,0.034,0.283-0.016,0.379-0.084 c0.098-0.07,0.186-0.197,0.203-0.318C199.619,330.856,199.6,330.714,199.517,330.607z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTips);
export default __webpack_public_path__ + "static/media/tips.a4f713a6ccb53651a2dacbf79c52b980.svg";
export { ForwardRef as ReactComponent };